<template>
<svg version="1.1" id="A-06" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 144 220" enable-background="new 0 0 144 220" xml:space="preserve">
<pattern  y="220" width="12.0001" height="21.642" patternUnits="userSpaceOnUse" id="SVGID_4_A-06" viewBox="0.9999 -27.302 12.0001 21.642" overflow="visible">
	<g>
		<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
		<g>
			<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
			<rect x="1" y="-27.302" fill="none" width="12" height="21.6418"/>
			<polygon fill="#6E682B" points="13,0 14,-0.999 14,-10.321 13,-11.321 12,-10.321 12,-0.999 			"/>
			<polygon fill="#6E682B" points="10.6,0 11.6,-0.999 11.6,-10.321 10.6,-11.321 9.6,-10.321 9.6,-0.999 			"/>
			<polygon fill="#6E682B" points="8.2,0 9.2,-0.999 9.2,-10.321 8.2,-11.321 7.2,-10.321 7.2,-0.999 			"/>
			<polygon fill="#6E682B" points="5.8,0 6.8,-0.999 6.8,-10.321 5.8,-11.321 4.8,-10.321 4.8,-0.999 			"/>
			<polygon fill="#6E682B" points="3.4,0 4.4,-0.999 4.4,-10.321 3.4,-11.321 2.4,-10.321 2.4,-0.999 			"/>
			<polygon fill="#6E682B" points="1,0 2,-0.999 2,-10.321 1,-11.321 0,-10.321 0,-0.999 			"/>
			<polygon fill="#6E682B" points="11.8,-10.821 12.8,-11.82 12.8,-21.142 11.8,-22.141 10.8,-21.142 10.8,-11.82 			"/>
			<polygon fill="#6E682B" points="9.4,-10.821 10.4,-11.82 10.4,-21.142 9.4,-22.141 8.4,-21.142 8.4,-11.82 			"/>
			<polygon fill="#6E682B" points="7,-10.821 8,-11.82 8,-21.142 7,-22.141 6,-21.142 6,-11.82 			"/>
			<polygon fill="#6E682B" points="4.6,-10.821 5.6,-11.82 5.6,-21.142 4.6,-22.141 3.6,-21.142 3.6,-11.82 			"/>
			<polygon fill="#6E682B" points="2.2,-10.821 3.2,-11.82 3.2,-21.142 2.2,-22.141 1.2,-21.142 1.2,-11.82 			"/>
			<polygon fill="#6E682B" points="13,-21.641 14,-22.64 14,-31.963 13,-32.962 12,-31.963 12,-22.64 			"/>
			<polygon fill="#6E682B" points="10.6,-21.641 11.6,-22.64 11.6,-31.963 10.6,-32.962 9.6,-31.963 9.6,-22.64 			"/>
			<polygon fill="#6E682B" points="8.2,-21.641 9.2,-22.64 9.2,-31.963 8.2,-32.962 7.2,-31.963 7.2,-22.64 			"/>
			<polygon fill="#6E682B" points="5.8,-21.641 6.8,-22.64 6.8,-31.963 5.8,-32.962 4.8,-31.963 4.8,-22.64 			"/>
			<polygon fill="#6E682B" points="3.4,-21.641 4.4,-22.64 4.4,-31.963 3.4,-32.962 2.4,-31.963 2.4,-22.64 			"/>
			<polygon fill="#6E682B" points="1,-21.641 2,-22.64 2,-31.963 1,-32.962 0,-31.963 0,-22.64 			"/>
		</g>
	</g>
</pattern>
<pattern  y="220" width="12.0001" height="21.642" patternUnits="userSpaceOnUse" id="SVGID_5_A-06" viewBox="0.9999 -27.302 12.0001 21.642" overflow="visible">
	<g>
		<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
		<g>
			<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
			<rect x="1" y="-27.302" fill="none" width="12" height="21.6418"/>
			<polygon fill="#898138" points="13,0 14,-0.999 14,-10.321 13,-11.321 12,-10.321 12,-0.999 			"/>
			<polygon fill="#898138" points="10.6,0 11.6,-0.999 11.6,-10.321 10.6,-11.321 9.6,-10.321 9.6,-0.999 			"/>
			<polygon fill="#898138" points="8.2,0 9.2,-0.999 9.2,-10.321 8.2,-11.321 7.2,-10.321 7.2,-0.999 			"/>
			<polygon fill="#898138" points="5.8,0 6.8,-0.999 6.8,-10.321 5.8,-11.321 4.8,-10.321 4.8,-0.999 			"/>
			<polygon fill="#898138" points="3.4,0 4.4,-0.999 4.4,-10.321 3.4,-11.321 2.4,-10.321 2.4,-0.999 			"/>
			<polygon fill="#898138" points="1,0 2,-0.999 2,-10.321 1,-11.321 0,-10.321 0,-0.999 			"/>
			<polygon fill="#898138" points="11.8,-10.821 12.8,-11.82 12.8,-21.142 11.8,-22.141 10.8,-21.142 10.8,-11.82 			"/>
			<polygon fill="#898138" points="9.4,-10.821 10.4,-11.82 10.4,-21.142 9.4,-22.141 8.4,-21.142 8.4,-11.82 			"/>
			<polygon fill="#898138" points="7,-10.821 8,-11.82 8,-21.142 7,-22.141 6,-21.142 6,-11.82 			"/>
			<polygon fill="#898138" points="4.6,-10.821 5.6,-11.82 5.6,-21.142 4.6,-22.141 3.6,-21.142 3.6,-11.82 			"/>
			<polygon fill="#898138" points="2.2,-10.821 3.2,-11.82 3.2,-21.142 2.2,-22.141 1.2,-21.142 1.2,-11.82 			"/>
			<polygon fill="#898138" points="13,-21.641 14,-22.64 14,-31.963 13,-32.962 12,-31.963 12,-22.64 			"/>
			<polygon fill="#898138" points="10.6,-21.641 11.6,-22.64 11.6,-31.963 10.6,-32.962 9.6,-31.963 9.6,-22.64 			"/>
			<polygon fill="#898138" points="8.2,-21.641 9.2,-22.64 9.2,-31.963 8.2,-32.962 7.2,-31.963 7.2,-22.64 			"/>
			<polygon fill="#898138" points="5.8,-21.641 6.8,-22.64 6.8,-31.963 5.8,-32.962 4.8,-31.963 4.8,-22.64 			"/>
			<polygon fill="#898138" points="3.4,-21.641 4.4,-22.64 4.4,-31.963 3.4,-32.962 2.4,-31.963 2.4,-22.64 			"/>
			<polygon fill="#898138" points="1,-21.641 2,-22.64 2,-31.963 1,-32.962 0,-31.963 0,-22.64 			"/>
		</g>
	</g>
</pattern>
<pattern  y="220" width="12.0001" height="21.642" patternUnits="userSpaceOnUse" id="SVGID_6_A-06" viewBox="0.9999 -27.302 12.0001 21.642" overflow="visible">
	<g>
		<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
		<g>
			<rect x="0.9999" y="-27.302" fill="none" width="12.0001" height="21.642"/>
			<rect x="1" y="-27.302" fill="none" width="12" height="21.6418"/>
			<polygon fill="#898138" points="13,0 14,-0.999 14,-10.321 13,-11.321 12,-10.321 12,-0.999 			"/>
			<polygon fill="#898138" points="10.6,0 11.6,-0.999 11.6,-10.321 10.6,-11.321 9.6,-10.321 9.6,-0.999 			"/>
			<polygon fill="#898138" points="8.2,0 9.2,-0.999 9.2,-10.321 8.2,-11.321 7.2,-10.321 7.2,-0.999 			"/>
			<polygon fill="#898138" points="5.8,0 6.8,-0.999 6.8,-10.321 5.8,-11.321 4.8,-10.321 4.8,-0.999 			"/>
			<polygon fill="#898138" points="3.4,0 4.4,-0.999 4.4,-10.321 3.4,-11.321 2.4,-10.321 2.4,-0.999 			"/>
			<polygon fill="#898138" points="1,0 2,-0.999 2,-10.321 1,-11.321 0,-10.321 0,-0.999 			"/>
			<polygon fill="#898138" points="11.8,-10.821 12.8,-11.82 12.8,-21.142 11.8,-22.141 10.8,-21.142 10.8,-11.82 			"/>
			<polygon fill="#898138" points="9.4,-10.821 10.4,-11.82 10.4,-21.142 9.4,-22.141 8.4,-21.142 8.4,-11.82 			"/>
			<polygon fill="#898138" points="7,-10.821 8,-11.82 8,-21.142 7,-22.141 6,-21.142 6,-11.82 			"/>
			<polygon fill="#898138" points="4.6,-10.821 5.6,-11.82 5.6,-21.142 4.6,-22.141 3.6,-21.142 3.6,-11.82 			"/>
			<polygon fill="#898138" points="2.2,-10.821 3.2,-11.82 3.2,-21.142 2.2,-22.141 1.2,-21.142 1.2,-11.82 			"/>
			<polygon fill="#898138" points="13,-21.641 14,-22.64 14,-31.963 13,-32.962 12,-31.963 12,-22.64 			"/>
			<polygon fill="#898138" points="10.6,-21.641 11.6,-22.64 11.6,-31.963 10.6,-32.962 9.6,-31.963 9.6,-22.64 			"/>
			<polygon fill="#898138" points="8.2,-21.641 9.2,-22.64 9.2,-31.963 8.2,-32.962 7.2,-31.963 7.2,-22.64 			"/>
			<polygon fill="#898138" points="5.8,-21.641 6.8,-22.64 6.8,-31.963 5.8,-32.962 4.8,-31.963 4.8,-22.64 			"/>
			<polygon fill="#898138" points="3.4,-21.641 4.4,-22.64 4.4,-31.963 3.4,-32.962 2.4,-31.963 2.4,-22.64 			"/>
			<polygon fill="#898138" points="1,-21.641 2,-22.64 2,-31.963 1,-32.962 0,-31.963 0,-22.64 			"/>
		</g>
	</g>
</pattern>
<g id="StemAndScrew_A-06">
	<linearGradient id="stemGradient_A-06" gradientUnits="userSpaceOnUse" x1="133.2609" y1="106.284" x2="128.7263" y2="114.1381">
		<stop  offset="0" style="stop-color:#F2F2F2"/>
		<stop  offset="1" style="stop-color:#C6C7C9"/>
	</linearGradient>

		<rect x="122.1" y="109.525" fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" width="17.8" height="1.35"/>
	<g>
		<linearGradient id="screwGradient_A-06" gradientUnits="userSpaceOnUse" x1="133.8141" y1="106.415" x2="129.3734" y2="114.1066">
			<stop  offset="0" style="stop-color:#F2F2F2"/>
			<stop  offset="1" style="stop-color:#B2B3B5"/>
		</linearGradient>
		<polygon fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" points="134.1,113.9343
			133.5527,113.7296 133.05,113.9343 132.5027,113.7296 132,113.9343 131.4527,113.7296 130.95,113.9343 130.4028,113.7296
			129.9,113.9343 129.1,113.9343 129.1,106.5657 129.6472,106.7704 130.15,106.5657 130.6972,106.7704 131.2,106.5657
			131.7472,106.7704 132.25,106.5657 132.7972,106.7704 133.3,106.5657 133.8472,106.7704 134.1,106.5657 		"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.1" y1="106.5657" x2="129.9" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.15" y1="106.5657" x2="130.95" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.2" y1="106.5657" x2="132" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.25" y1="106.5657" x2="133.05" y2="113.9343"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="129.6472" y1="106.7704" x2="130.4028" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="130.6972" y1="106.7704" x2="131.4527" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="131.7472" y1="106.7704" x2="132.5027" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="132.7972" y1="106.7704" x2="133.5527" y2="113.7296"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.8472" y1="106.7704" x2="134.1" y2="109.0985"/>

			<line fill="whitesmoke" stroke="#B6B8BA" stroke-width="0.2601" stroke-miterlimit="10" x1="133.3" y1="106.5657" x2="134.1" y2="113.9343"/>
	</g>
</g>
<g id="CrownAndArrows_A-06">
  <g id="Arrows_A-06">
    <g id="Arrow_clockwise_A-06">
      <path fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M137.6404,94.8417
        c-0.5838,0.3434-1.2641,0.5403-1.9904,0.5403c-2.1716,0-3.932-1.7604-3.932-3.932c0-2.1716,1.7604-3.932,3.932-3.932
        c2.1716,0,3.932,1.7604,3.932,3.932"/>
      <polyline fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="140.1244,89.3858 139.582,91.45
        138.0707,89.9533 		"/>
    </g>
    <g id="Arrow_counterclockwise_A-06">
      <path fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" d="M133.6596,132.3417
        c0.5838,0.3434,1.2641,0.5403,1.9904,0.5403c2.1716,0,3.932-1.7604,3.932-3.932c0-2.1716-1.7604-3.932-3.932-3.932
        c-2.1716,0-3.932,1.7604-3.932,3.932"/>
      <polyline fill="none" stroke="#231F20" stroke-width="0.5216" stroke-miterlimit="10" points="131.1756,126.8858 131.718,128.95
        133.2293,127.4533 		"/>
    </g>
  </g>
  <g id="Crown_A-06">
    <path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M139.0869,118.3412c0,0,1.4551-2.1062,1.4551-8.3206s-1.4551-8.3237-1.4551-8.3237"/>
    <polygon fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" points="138.9252,119.3542
      139.0872,118.9563 139.0872,101.0562 138.9252,100.6613 138.3132,100.0853 131.8052,100.0853 131.1952,101.6973
      131.1872,118.3412 131.8252,119.9283 138.3232,119.9283 		"/>
    <polygon fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" points="131.8142,101.6973
      131.1952,101.6973 131.8052,100.1082 138.3052,100.1082 138.9142,101.6973 138.3132,101.6973 138.9262,103.0502
      138.3262,103.5172 138.9352,105.0273 138.3262,105.8853 138.9072,107.4402 138.3262,108.6263 138.9352,109.9942
      138.3262,111.4113 138.9422,112.5963 138.3032,114.1503 138.9122,115.0092 138.3032,116.5222 138.9222,116.9872
      138.3162,118.3412 138.9322,118.3412 138.3232,119.9283 131.8252,119.9283 131.2152,118.3412 131.8162,118.3412
      131.2002,116.9872 131.8032,116.5222 131.1942,115.0092 131.8032,114.1503 131.2232,112.5963 131.8032,111.4113
      131.2252,109.9942 131.8172,108.6263 131.1872,107.4402 131.8252,105.8853 131.2152,105.0273 131.8252,103.5172
      131.2082,103.0502 			"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8139" y1="101.6969" x2="138.3128" y2="101.6969"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.825" y1="103.5172" x2="138.3258" y2="103.5172"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.825" y1="105.8851" x2="138.3258" y2="105.8851"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8172" y1="108.6261" x2="138.3258" y2="108.6261"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8035" y1="111.4113" x2="138.3258" y2="111.4113"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8035" y1="114.1503" x2="138.3037" y2="114.1503"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8035" y1="116.5221" x2="138.3037" y2="116.5221"/>
    <line fill="whitesmoke" stroke="#808184" stroke-width="0.2602" stroke-miterlimit="10" x1="131.8165" y1="118.3412" x2="138.3167" y2="118.3412"/>
  </g>
</g>
<g id="Strap_A-06" style="mix-blend-mode: multiply;">
	<rect x="44.6704" y="12.6964" fill="#E6E6E6" width="55.2006" height="194.6012"/>
	<g>
		<path fill="lightgrey" d="M72.0818,10.7683c0,0,28.4735,0.2987,29.6841,1.5093s1.5094,25.5419,1.5094,25.5419v11.1317
			H40.8884V37.8195c0,0,0.2992-24.3312,1.5092-25.5418S72.0818,10.7683,72.0818,10.7683z"/>
		<path fill="lightgrey" d="M72.0818,216.8683c0,0,28.4735-0.2988,29.6841-1.5094s1.5094-33.1732,1.5094-33.1732v-11.1318
			H40.8884v11.1318c0,0,0.2987,31.9626,1.5094,33.1732S72.0818,216.8683,72.0818,216.8683z"/>
	</g>
	<g>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="41.97" y1="42.4615" x2="43.0516" y2="42.4615"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" stroke-dasharray="2.1113,1.0556" x1="44.1073" y1="42.4615" x2="100.5842" y2="42.4615"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="101.112" y1="42.4615" x2="102.1936" y2="42.4615"/>
	</g>
	<g>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="41.97" y1="177.5436" x2="43.0516" y2="177.5436"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" stroke-dasharray="2.1113,1.0556" x1="44.1073" y1="177.5436" x2="100.5842" y2="177.5436"/>
    <line fill="none" stroke="#231F20" stroke-width="0.7636" stroke-miterlimit="10" x1="101.112" y1="177.5436" x2="102.1936" y2="177.5436"/>
	</g>
</g>
<g id="Case_A-06">

		<linearGradient id="SVGID_12_A-06" gradientUnits="userSpaceOnUse" x1="13.2268" y1="461.2339" x2="130.938" y2="529.1945" gradientTransform="matrix(1 0 0 1 0 -385.2055)">
		<stop  offset="0" style="stop-color:#4B4B4B"/>
		<stop  offset="1" style="stop-color:#000000"/>
	</linearGradient>
	<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M20.0415,138.9359c6.2693,12.4476,10.6709,25.7508,13.0629,39.4813
		c2.5204,1.44,5.1191,2.7386,7.784,3.8895l0.0124-20.0826c0.0002-0.4698,0.3811-0.8505,0.8509-0.8503
		c0.1136,0,0.2261,0.0229,0.3308,0.0671l0.0013-0.0046c18.5412,10.8002,41.4566,10.8007,59.9982,0.0013l0.0007,0.0033
		c0.433-0.1829,0.9323,0.0198,1.1152,0.4528c0.0442,0.1046,0.067,0.2169,0.0671,0.3304l0.0124,20.0826
		c2.6647-1.1508,5.2632-2.4493,7.7834-3.8895c2.3927-13.7303,6.7942-27.0335,13.0628-39.4814
		c9.9847-17.9928,9.9847-39.8627,0-57.8555c-6.2686-12.4475-10.67-25.7501-13.0628-39.48c-2.52-1.4404-5.1185-2.7389-7.7834-3.8894
		l-0.0124,20.0825c0.0001,0.4694-0.3803,0.8501-0.8498,0.8502c-0.1143,0-0.2274-0.023-0.3325-0.0676v0.004
		c-18.541-10.8004-41.4564-10.8007-59.9976-0.0006l-0.0026-0.0033c-0.4317,0.1835-0.9305-0.0177-1.114-0.4494
		c-0.0448-0.1054-0.0678-0.2187-0.0677-0.3332l-0.0126-20.0832c-2.665,1.1507-5.2637,2.4491-7.784,3.8894
		c-2.3925,13.7302-6.7936,27.0334-13.0616,39.4815c-9.9838,17.9908-9.9847,39.8583-0.0026,57.85"/>
	<g>

			<linearGradient id="SVGID_13_A-06" gradientUnits="userSpaceOnUse" x1="43.5894" y1="445.8612" x2="100.577" y2="544.5666" gradientTransform="matrix(1 0 0 1 0 -385.2055)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" d="M129.0613,110.0083
			c0.0001,31.4681-25.5099,56.9781-56.978,56.9782c-31.4681,0-56.9781-25.5099-56.9782-56.978s25.5099-56.9781,56.978-56.9782
			h0.0001C103.5513,53.0303,129.0612,78.5403,129.0613,110.0083z"/>

			<linearGradient id="SVGID_14_A-06" gradientUnits="userSpaceOnUse" x1="116.2789" y1="520.7297" x2="27.8869" y2="469.6967" gradientTransform="matrix(1 0 0 1 0.0003 -385.2055)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>

			<circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" cx="72.0832" cy="110.0077" r="51.0246"/>

			<linearGradient id="SVGID_15_A-06" gradientUnits="userSpaceOnUse" x1="47.5163" y1="452.6618" x2="96.6498" y2="537.7636" gradientTransform="matrix(1 0 0 1 0 -385.2055)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M121.2082,110.0072c0.0001,27.1311-21.994,49.1254-49.1252,49.1254
			c-27.1312,0.0001-49.1253-21.994-49.1254-49.1252s21.994-49.1253,49.1252-49.1254c0.0001,0,0.0003,0,0.0004,0
			c27.1305-0.0004,49.1246,21.9929,49.125,49.1234C121.2082,110.006,121.2082,110.0067,121.2082,110.0072z"/>

			<linearGradient id="SVGID_16_A-06" gradientUnits="userSpaceOnUse" x1="96.1823" y1="536.9534" x2="47.9843" y2="453.472" gradientTransform="matrix(1 0 0 1 0 -385.2055)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>
		<path fill="whitesmoke" stroke="#6E6F71" stroke-width="0.2601" d="M120.2733,110.0072c0,26.6146-21.5754,48.19-48.19,48.19s-48.19-21.5754-48.19-48.19
			s21.5753-48.1899,48.1899-48.19S120.2732,83.3925,120.2733,110.0072C120.2733,110.0072,120.2733,110.0072,120.2733,110.0072z"/>

			<linearGradient id="SVGID_17_A-06" gradientUnits="userSpaceOnUse" x1="25.3096" y1="495.2128" x2="118.8558" y2="495.2128" gradientTransform="matrix(1 0 0 1 0.0001 -385.2055)">
			<stop  offset="0" style="stop-color:#4B4B4B"/>
			<stop  offset="1" style="stop-color:#000000"/>
		</linearGradient>

			<circle fill="whitesmoke" stroke="#6E6F71" stroke-width="0.288" stroke-miterlimit="10" cx="72.0828" cy="110.0073" r="46.7731"/>
	</g>
</g>
<g id="Dial_rings_A-06">
  <g id="Day-ring_A-06">
	<path fill="#FFFFFF" d="M104.5098,110.2519c0,17.9253-14.5314,32.4567-32.4567,32.4567s-32.4567-14.5314-32.4567-32.4567
		s14.5314-32.4567,32.4567-32.4567S104.5098,92.3266,104.5098,110.2519z M72.0531,85.4489
		c-13.6984,0-24.8031,11.1047-24.8031,24.8031s11.1047,24.8031,24.8031,24.8031s24.8031-11.1047,24.8031-24.8031
		S85.7514,85.4489,72.0531,85.4489z"/>
	<g>
		<g>
			<path fill="#231F20" d="M98.3767,109.0465v-0.3027c0.2539-0.208,0.5215-0.3125,0.8018-0.3125s0.5186,0.0957,0.7139,0.2871
				s0.293,0.4238,0.293,0.7002c0,0.5459-0.4219,1.2988-1.2646,2.2588h1.5996v0.2363h-2.1836
				c1.0615-1.0225,1.5928-1.8525,1.5928-2.4902c0-0.2119-0.0742-0.3896-0.2217-0.5342s-0.3311-0.2168-0.5488-0.2168
				c-0.1445,0-0.2744,0.0293-0.3887,0.0889C98.655,108.8199,98.5242,108.9156,98.3767,109.0465z"/>
			<path fill="#231F20" d="M101.4675,110.1246c-0.3008-0.2031-0.4502-0.4619-0.4502-0.7754c0-0.2471,0.0898-0.4629,0.2705-0.6445
				c0.1807-0.1826,0.3926-0.2734,0.6367-0.2734c0.251,0,0.4668,0.0898,0.6475,0.2695s0.2705,0.3945,0.2705,0.6436
				c0,0.3232-0.1455,0.583-0.4375,0.7803c0.3379,0.2031,0.5068,0.4873,0.5068,0.8516c0,0.2754-0.0938,0.5078-0.2822,0.6973
				c-0.1875,0.1895-0.418,0.2842-0.6895,0.2842c-0.2764,0-0.5098-0.0928-0.7002-0.2803c-0.1914-0.1865-0.2871-0.4141-0.2871-0.6816
				C100.9529,110.6217,101.1247,110.3317,101.4675,110.1246z M102.656,110.9615c0-0.1953-0.0713-0.3623-0.2129-0.5
				s-0.3145-0.2061-0.5186-0.2061c-0.1982,0-0.3672,0.0713-0.5068,0.2148c-0.1387,0.1436-0.209,0.3154-0.209,0.5156
				c0,0.2021,0.0703,0.374,0.2119,0.5166c0.1406,0.1426,0.3145,0.2139,0.5195,0.2139c0.208,0,0.3789-0.0713,0.5137-0.2139
				S102.656,111.1793,102.656,110.9615z M101.2751,109.3444c0,0.1875,0.0635,0.3457,0.1904,0.4746
				c0.1279,0.1299,0.2842,0.1953,0.4697,0.1953c0.1865,0,0.3418-0.0654,0.4648-0.1953c0.123-0.1289,0.1846-0.292,0.1846-0.4863
				c0-0.1826-0.0645-0.3379-0.1924-0.4668s-0.2832-0.1934-0.4678-0.1934c-0.1797,0-0.333,0.0654-0.46,0.1963
				C101.3386,108.9986,101.2751,109.1578,101.2751,109.3444z"/>
		</g>
		<g>
			<path fill="#231F20" d="M97.5964,103.7716l-0.0625-0.2959c0.207-0.2549,0.4492-0.4111,0.7227-0.4678
				c0.2754-0.0566,0.5273-0.0107,0.7578,0.1377c0.2285,0.1479,0.3711,0.356,0.4277,0.6274
				c0.1094,0.5342-0.1504,1.3564-0.7852,2.4663l1.5684-0.3218l0.0469,0.2314l-2.1387,0.4395
				c0.834-1.2148,1.1875-2.1353,1.0586-2.7593c-0.043-0.208-0.1504-0.3667-0.3242-0.4785c-0.1738-0.1123-0.3672-0.1465-0.582-0.1025
				c-0.1406,0.0293-0.2617,0.0845-0.3633,0.165C97.823,103.4943,97.7136,103.6144,97.5964,103.7716z"/>
			<path fill="#231F20" d="M101.1394,106.0157l-0.1738-0.1523c0.6309-0.687,0.9375-1.3291,0.9199-1.9248
				c-0.2266,0.2217-0.457,0.3574-0.6875,0.4053c-0.2656,0.0542-0.5059,0.0112-0.7227-0.1299
				c-0.2168-0.1396-0.3516-0.3398-0.4043-0.6016c-0.0566-0.2725-0.0156-0.5151,0.127-0.7275
				c0.1406-0.2134,0.3496-0.3477,0.627-0.4043c0.3203-0.0659,0.5938-0.0127,0.8223,0.1602c0.2305,0.1719,0.3809,0.4409,0.457,0.8052
				C102.2761,104.2838,101.9538,105.1407,101.1394,106.0157z M101.8679,103.631c-0.0059-0.0527-0.0137-0.103-0.0234-0.1509
				c-0.0605-0.2891-0.1738-0.502-0.3418-0.6372c-0.168-0.1357-0.373-0.1792-0.6152-0.1294
				c-0.1992,0.041-0.3535,0.1421-0.4648,0.3013c-0.1113,0.1582-0.1445,0.3359-0.1055,0.5322
				c0.041,0.1992,0.1426,0.353,0.3027,0.4595c0.1602,0.1074,0.3398,0.1406,0.5391,0.1001
				C101.4421,104.048,101.6785,103.8898,101.8679,103.631z"/>
		</g>
		<g>
			<path fill="#231F20" d="M95.8455,98.5695l-0.0977-0.2261c0.127-0.2148,0.3184-0.3779,0.5781-0.4893
				c0.2754-0.1182,0.5332-0.1406,0.7734-0.0664c0.2402,0.0737,0.4092,0.2275,0.5088,0.459c0.0713,0.166,0.0859,0.335,0.043,0.5063
				c-0.042,0.1724-0.1445,0.3267-0.3066,0.4644l0.0039,0.0093c0.4678-0.0386,0.7871,0.1421,0.958,0.5415
				c0.1201,0.2793,0.1221,0.54,0.0049,0.7822c-0.1162,0.2432-0.3037,0.4199-0.5615,0.5303
				c-0.2617,0.1123-0.5264,0.1646-0.7949,0.1562l-0.0918-0.2163c0.2598,0.0073,0.5146-0.0425,0.7646-0.1499
				c0.2188-0.0938,0.3701-0.231,0.4521-0.4131c0.083-0.1826,0.0811-0.3735-0.0049-0.5737c-0.0928-0.2153-0.2383-0.356-0.4365-0.4214
				c-0.1982-0.0659-0.4248-0.042-0.6777,0.0713l-0.0947-0.2217c0.2314-0.0996,0.3936-0.2393,0.4863-0.4209
				c0.0908-0.1816,0.1006-0.356,0.0283-0.5254c-0.0723-0.167-0.2012-0.2788-0.3877-0.333
				c-0.1865-0.0547-0.3838-0.0376-0.5898,0.0508C96.1775,98.1813,95.991,98.3424,95.8455,98.5695z"/>
			<path fill="#231F20" d="M98.7908,96.7965c0.2832-0.1211,0.584-0.0815,0.8994,0.1191c0.3174,0.2002,0.5869,0.562,0.8105,1.083
				c0.208,0.4858,0.2803,0.916,0.2148,1.2896c-0.0654,0.3745-0.2402,0.623-0.5244,0.7456c-0.2988,0.1279-0.6055,0.0889-0.918-0.1172
				c-0.3135-0.2051-0.5703-0.543-0.7715-1.0107c-0.25-0.584-0.3311-1.0527-0.2412-1.4072S98.5271,96.9098,98.7908,96.7965z
				 M100.0769,99.8199c0.2354-0.1011,0.3682-0.3145,0.3975-0.6416s-0.043-0.6934-0.2178-1.1006
				c-0.1709-0.3994-0.3838-0.7002-0.6357-0.9053c-0.2529-0.2036-0.498-0.2559-0.7344-0.1543
				c-0.2236,0.0957-0.3525,0.3047-0.3867,0.6279c-0.0352,0.3232,0.0361,0.6909,0.2129,1.104
				c0.1797,0.4175,0.3955,0.7241,0.6484,0.9204C99.614,99.8663,99.8533,99.9156,100.0769,99.8199z"/>
		</g>
		<g>
			<path fill="#231F20" d="M93.0076,94.0206l-0.1406-0.2017c0.0801-0.2354,0.2363-0.4346,0.4678-0.5957
				c0.2471-0.1714,0.4951-0.2451,0.7451-0.2202c0.248,0.0234,0.4463,0.1401,0.5898,0.3467c0.1035,0.1484,0.1514,0.311,0.1445,0.4873
				c-0.0078,0.1772-0.0762,0.3491-0.207,0.5166l0.0059,0.0078c0.4502-0.1313,0.7988-0.0186,1.0469,0.3384
				c0.1738,0.249,0.2285,0.5039,0.1631,0.7646c-0.0654,0.2617-0.2129,0.4722-0.4434,0.6323
				c-0.2344,0.1631-0.4834,0.2676-0.7471,0.313l-0.1348-0.1934c0.2559-0.0449,0.4961-0.1455,0.7197-0.3008
				c0.1943-0.1357,0.3154-0.3003,0.3594-0.4956c0.0439-0.1948,0.0049-0.3823-0.1201-0.561
				c-0.1338-0.1924-0.3047-0.3003-0.5127-0.3247s-0.4248,0.0439-0.6494,0.2065l-0.1367-0.1982
				c0.207-0.144,0.3369-0.3135,0.3906-0.5103c0.0527-0.1963,0.0273-0.3691-0.0781-0.5205c-0.1035-0.1489-0.252-0.2319-0.4473-0.2476
				c-0.1934-0.0156-0.3828,0.04-0.5664,0.1685C93.2546,93.5734,93.1052,93.7692,93.0076,94.0206z"/>
			<path fill="#231F20" d="M95.6648,91.6564l1.9639,2.8213l-0.21,0.1465l-1.9639-2.8213L95.6648,91.6564z"/>
		</g>
		<g>
			<path fill="#231F20" d="M90.5701,88.1954l2.4912,2.3687l-0.1768,0.186l-2.4912-2.3687L90.5701,88.1954z"/>
		</g>
		<g>
			<path fill="#231F20" d="M85.6218,86.2057l-0.2559-0.1602c-0.043-0.3252,0.0098-0.6074,0.1582-0.8457
				c0.1484-0.2378,0.3555-0.3892,0.6211-0.4536s0.5156-0.0244,0.75,0.1216c0.4629,0.2891,0.8789,1.0444,1.248,2.2681l0.8457-1.3574
				l0.2012,0.125l-1.1562,1.8525c-0.3047-1.4414-0.7285-2.3311-1.2695-2.6685c-0.1816-0.1123-0.3711-0.1431-0.5723-0.0942
				c-0.1992,0.0483-0.3574,0.1655-0.4727,0.3511c-0.0762,0.1221-0.1211,0.248-0.1309,0.3765
				C85.5769,85.8497,85.5886,86.0118,85.6218,86.2057z"/>
		</g>
		<g>
			<path fill="#231F20" d="M80.4158,83.7775l-0.2305-0.0854c-0.0693-0.2393-0.0547-0.4912,0.043-0.7559
				c0.1045-0.2817,0.2656-0.4834,0.4854-0.6064c0.2178-0.123,0.4463-0.1396,0.6826-0.0522c0.1699,0.063,0.3027,0.1685,0.3965,0.3169
				c0.0957,0.1499,0.1377,0.3301,0.125,0.543l0.0098,0.0029c0.2949-0.3647,0.6455-0.4717,1.0527-0.3213
				c0.2852,0.1055,0.4756,0.2842,0.5703,0.5352c0.0967,0.252,0.0947,0.5098-0.002,0.7725
				c-0.0996,0.2676-0.2441,0.4956-0.4346,0.6836l-0.2207-0.0815c0.1846-0.1831,0.3232-0.4028,0.4189-0.6587
				c0.082-0.2227,0.0869-0.4268,0.0117-0.6113c-0.0752-0.1855-0.2148-0.3164-0.4199-0.3921
				c-0.2188-0.0815-0.4219-0.0723-0.6055,0.0259c-0.1846,0.0986-0.3232,0.2793-0.415,0.5405l-0.2256-0.0835
				c0.0869-0.2373,0.0977-0.4512,0.0293-0.6426s-0.1875-0.3184-0.3613-0.3828c-0.1699-0.063-0.3398-0.0464-0.5088,0.0518
				c-0.167,0.0977-0.291,0.252-0.3691,0.4629C80.363,83.2692,80.3513,83.5153,80.4158,83.7775z"/>
		</g>
		<g>
			<path fill="#231F20" d="M74.6838,81.0611l1.9268,0.2954l0.0723-0.4741l0.2041,0.0312l-0.0723,0.4741l1.3115,0.2007
				l-0.0391,0.2529l-1.3115-0.2007l-0.2373,1.5498l-0.083-0.0127l-1.7861-2.0215L74.6838,81.0611z M76.5715,81.6095l-1.4326-0.2197
				l1.249,1.418L76.5715,81.6095z"/>
		</g>
		<g>
			<path fill="#231F20" d="M68.7952,81.0748l0.2383-0.0127l0.0615,1.2148l1.0869-0.0557c-0.0195-0.0918-0.0317-0.1836-0.0361-0.2734
				c-0.0176-0.3428,0.064-0.623,0.2461-0.8408c0.1826-0.2178,0.436-0.335,0.7593-0.3516c0.3184-0.0156,0.5884,0.0762,0.8101,0.2764
				c0.2227,0.2012,0.3418,0.4609,0.3579,0.7783c0.0132,0.2656-0.0479,0.5449-0.1841,0.8379l-0.293,0.0146
				c0.1694-0.3291,0.2471-0.6123,0.2354-0.8496c-0.0127-0.2461-0.103-0.4443-0.272-0.5947
				c-0.1675-0.1514-0.3755-0.2207-0.6216-0.208c-0.2676,0.0137-0.4731,0.1084-0.6172,0.2852
				c-0.1426,0.1768-0.2075,0.4053-0.1934,0.6846c0.0078,0.1523,0.04,0.3086,0.0981,0.4688L68.8689,82.53L68.7952,81.0748z"/>
		</g>
		<g>
			<path fill="#231F20" d="M62.9978,82.5406l0.1396-0.1914c0.6865,0.582,1.3447,0.8516,1.9736,0.8105
				c-0.2344-0.1885-0.3838-0.4111-0.4502-0.6689c-0.0684-0.2646-0.0391-0.5088,0.0889-0.7314
				c0.127-0.2236,0.3203-0.3682,0.5771-0.4346c0.2715-0.0703,0.5186-0.04,0.7422,0.0928c0.2217,0.1318,0.3682,0.3359,0.4395,0.6104
				c0.0791,0.3076,0.0371,0.582-0.1279,0.8203c-0.1631,0.2393-0.4238,0.4053-0.7793,0.4971
				C64.7888,83.5563,63.9206,83.2877,62.9978,82.5406z M65.4099,83.1305c0.0605-0.0088,0.1182-0.0195,0.1729-0.0342
				c0.2705-0.0693,0.4678-0.1973,0.5938-0.3828c0.125-0.1846,0.1592-0.3877,0.1016-0.6104
				c-0.0518-0.2012-0.1592-0.3545-0.3223-0.459c-0.1641-0.1025-0.3389-0.1309-0.5283-0.0811
				c-0.2002,0.0518-0.3506,0.165-0.4502,0.3379c-0.1006,0.1729-0.125,0.3604-0.0723,0.5625
				C64.9724,82.7233,65.1404,82.9459,65.4099,83.1305z"/>
		</g>
		<g>
			<path fill="#231F20" d="M57.3567,84.3209l3.8188-0.1221l0.0137,0.2402l-3.4536,0.1133l0.8257,1.6836l-0.2139,0.1055
				L57.3567,84.3209z"/>
		</g>
		<g>
			<path fill="#231F20" d="M54.719,88.0641c0.0229,0.3613-0.0898,0.6387-0.3379,0.8301c-0.1953,0.1523-0.4204,0.2129-0.6748,0.1816
				c-0.2549-0.0312-0.4565-0.1445-0.6064-0.3369c-0.1533-0.1982-0.2148-0.4248-0.1831-0.6768s0.1465-0.4551,0.3438-0.6084
				c0.2554-0.1982,0.5503-0.2412,0.8848-0.1309c-0.0464-0.3916,0.0747-0.6992,0.3628-0.9219
				c0.2178-0.1689,0.4595-0.2373,0.7246-0.2041c0.2642,0.0322,0.4805,0.1562,0.647,0.3711c0.1685,0.2188,0.2383,0.46,0.2065,0.7256
				c-0.0303,0.2656-0.1519,0.4805-0.3633,0.6436C55.427,88.1666,55.093,88.2086,54.719,88.0641z M54.22,88.693
				c0.1479-0.1143,0.2339-0.2617,0.2583-0.4414c0.0249-0.1797-0.019-0.3428-0.1323-0.4902
				c-0.1147-0.1475-0.2612-0.2295-0.4395-0.248c-0.1772-0.0176-0.3438,0.0332-0.4971,0.1523
				c-0.1445,0.1113-0.2285,0.2578-0.252,0.4375c-0.0239,0.1797,0.0205,0.3428,0.1328,0.4883
				c0.1104,0.1426,0.2563,0.2236,0.437,0.2441C53.908,88.8551,54.0725,88.8082,54.22,88.693z M54.6536,86.6119
				c-0.1548,0.1201-0.2432,0.2783-0.2651,0.4746s0.0293,0.374,0.1538,0.5361c0.1216,0.1562,0.2817,0.2461,0.4805,0.2695
				c0.1987,0.0215,0.3774-0.0283,0.5356-0.1504c0.1602-0.125,0.2529-0.2852,0.2793-0.4844s-0.0234-0.3789-0.1489-0.541
				c-0.1274-0.1641-0.2886-0.2568-0.4839-0.2754C55.01,86.4215,54.8254,86.4781,54.6536,86.6119z"/>
		</g>
		<g>
			<path fill="#231F20" d="M51.8557,90.6656L51.842,90.897c-0.9307-0.0791-1.6265,0.0713-2.0859,0.4502
				c0.3145,0.043,0.5625,0.1426,0.7417,0.2959c0.2056,0.1768,0.3188,0.3936,0.3398,0.6504c0.022,0.2568-0.0547,0.4863-0.228,0.6885
				c-0.1812,0.2109-0.3994,0.3262-0.6538,0.3447c-0.2549,0.0186-0.4888-0.0645-0.7031-0.248
				c-0.248-0.2129-0.3735-0.4619-0.3774-0.749s0.1157-0.5713,0.3579-0.8535C49.7903,90.8278,50.6643,90.5572,51.8557,90.6656z
				 M49.5242,91.5494c-0.0381,0.0361-0.0732,0.0732-0.1055,0.1123c-0.1919,0.2227-0.291,0.4434-0.2954,0.6582
				c-0.0044,0.2168,0.0874,0.4043,0.2754,0.5664c0.1543,0.1318,0.3286,0.1934,0.522,0.1816
				c0.1929-0.0078,0.355-0.0898,0.4854-0.2422c0.1333-0.1543,0.1924-0.3271,0.1787-0.5195
				c-0.0132-0.1914-0.0972-0.3535-0.2515-0.4863C50.114,91.6315,49.8445,91.5416,49.5242,91.5494z"/>
		</g>
		<g>
			<path fill="#231F20" d="M47.1614,98.4645l1.6685-3.0059l0.2241,0.125l-1.6685,3.0059L47.1614,98.4645z"/>
			<path fill="#231F20" d="M45.0466,97.3414c-0.27-0.1494-0.4224-0.4111-0.457-0.7832c-0.0356-0.374,0.0854-0.8086,0.3608-1.3047
				c0.2563-0.4619,0.5527-0.7822,0.8877-0.959c0.3359-0.1777,0.6396-0.1914,0.9111-0.041c0.2842,0.1582,0.4404,0.4238,0.4692,0.7969
				c0.0293,0.374-0.0801,0.7832-0.3271,1.2295c-0.3086,0.5557-0.6299,0.9053-0.9653,1.0518S45.2976,97.4811,45.0466,97.3414z
				 M46.6497,94.4742c-0.2241-0.124-0.4741-0.0986-0.7505,0.0781c-0.2764,0.1777-0.5215,0.459-0.7368,0.8467
				c-0.2104,0.3789-0.3193,0.7314-0.3267,1.0566c-0.0063,0.3252,0.1021,0.5498,0.3276,0.6748
				c0.2124,0.1182,0.4565,0.0918,0.7334-0.0781c0.2764-0.1699,0.5239-0.4521,0.7422-0.8447
				c0.2202-0.3975,0.3306-0.7559,0.3306-1.0762C46.9695,94.8121,46.863,94.5934,46.6497,94.4742z"/>
		</g>
		<g>
			<path fill="#231F20" d="M45.2986,103.7184l1.0288-3.2793l0.2446,0.0762l-1.0293,3.2803L45.2986,103.7184z"/>
			<path fill="#231F20" d="M42.8933,102.9645l1.0293-3.2803l0.2446,0.0771l-1.0288,3.2793L42.8933,102.9645z"/>
		</g>
		<g>
			<path fill="#231F20" d="M44.531,109.2379l0.3477-3.4199l0.2549,0.0254l-0.3477,3.4199L44.531,109.2379z"/>
			<path fill="#231F20" d="M43.2346,108.5328l-0.0308,0.3018c-0.2739,0.1807-0.5508,0.2578-0.8301,0.2295
				c-0.2788-0.0283-0.5054-0.1484-0.6802-0.3584c-0.1753-0.21-0.2485-0.4502-0.2207-0.7256c0.0552-0.543,0.5503-1.25,1.4868-2.1191
				l-1.5918-0.1621l0.0239-0.2354l2.1719,0.2207c-1.1592,0.9102-1.7715,1.6816-1.8359,2.3164
				c-0.0215,0.2109,0.0337,0.3955,0.1665,0.5537c0.1318,0.1592,0.3066,0.249,0.5239,0.2715c0.1436,0.0146,0.2754-0.002,0.396-0.0488
				C42.9343,108.7301,43.074,108.6481,43.2346,108.5328z"/>
		</g>
		<g>
			<path fill="#231F20" d="M44.8894,114.7975l-0.3477-3.4199l0.2549-0.0264l0.3477,3.4199L44.8894,114.7975z"/>
			<path fill="#231F20" d="M43.3464,114.5289l0.0244,0.2451c-0.1846,0.167-0.417,0.2656-0.6973,0.2939
				c-0.2988,0.0303-0.5508-0.0259-0.7578-0.1685c-0.207-0.1421-0.3223-0.3394-0.3477-0.5903
				c-0.0186-0.1797,0.0176-0.3452,0.1094-0.4956c0.0928-0.1514,0.2363-0.2686,0.4326-0.3511l-0.001-0.0098
				c-0.458-0.104-0.709-0.3716-0.7529-0.8042c-0.0303-0.3018,0.0459-0.5513,0.2295-0.7476c0.1836-0.1973,0.415-0.3096,0.6943-0.3379
				c0.2842-0.0293,0.5527,0.001,0.8057,0.0894l0.0234,0.2334c-0.2451-0.0845-0.5039-0.1133-0.7754-0.0854
				c-0.2363,0.0239-0.4209,0.1099-0.5547,0.2583c-0.1338,0.1489-0.1895,0.332-0.167,0.5488c0.0234,0.2334,0.1211,0.4111,0.29,0.5327
				c0.1699,0.123,0.3936,0.1675,0.668,0.1348l0.0244,0.2402c-0.251,0.0254-0.4473,0.1104-0.5898,0.2563
				c-0.1416,0.1455-0.2031,0.3096-0.1846,0.4932c0.0186,0.1807,0.1084,0.3257,0.2705,0.4331
				c0.1621,0.1069,0.3545,0.1504,0.5781,0.1279C42.9128,114.8009,43.1394,114.7028,43.3464,114.5289z"/>
		</g>
		<g>
			<path fill="#231F20" d="M46.3621,120.1754l-1.0293-3.2803l0.2441-0.0771l1.0293,3.2803L46.3621,120.1754z"/>
			<path fill="#231F20" d="M43.4841,121.1246l-0.583-1.8594l-0.458,0.1436l-0.0625-0.1973l0.458-0.1436l-0.3965-1.2656
				l0.2441-0.0771l0.3965,1.2656l1.4961-0.4697l0.0254,0.0801l-1.0283,2.4941L43.4841,121.1246z M43.1453,119.1881l0.4336,1.3828
				l0.7227-1.7451L43.1453,119.1881z"/>
		</g>
		<g>
			<path fill="#231F20" d="M48.8855,125.1432l-1.668-3.0059l0.2246-0.124l1.668,3.0049L48.8855,125.1432z"/>
			<path fill="#231F20" d="M46.1921,126.6383l-0.1162-0.208l1.0635-0.5898l-0.5283-0.9512
				c-0.0742,0.0576-0.1514,0.1094-0.2295,0.1533c-0.3008,0.166-0.5879,0.2148-0.8633,0.1484
				c-0.2764-0.0684-0.4932-0.2441-0.6504-0.5273c-0.1543-0.2783-0.1914-0.5625-0.1094-0.8486
				c0.084-0.2891,0.2637-0.5098,0.542-0.6641c0.2324-0.1289,0.5098-0.1963,0.833-0.2041l0.1416,0.2559
				c-0.3701-0.0059-0.6582,0.0488-0.8662,0.1641c-0.2148,0.1191-0.3535,0.2881-0.4141,0.5059
				c-0.0615,0.2178-0.0332,0.4346,0.0869,0.6494c0.1299,0.2354,0.3057,0.3779,0.5283,0.4287
				c0.2207,0.0508,0.4551,0.0078,0.6992-0.1279c0.1338-0.0742,0.2598-0.1729,0.377-0.2949l0.7793,1.4033L46.1921,126.6383z"/>
		</g>
		<g>
			<path fill="#231F20" d="M52.3542,129.5006l-2.2383-2.6084l0.1943-0.167l2.2393,2.6084L52.3542,129.5006z"/>
			<path fill="#231F20" d="M50.2038,131.4068l-0.2334-0.041c0.2197-0.873,0.1719-1.583-0.1416-2.1299
				c-0.0664,0.2939-0.2012,0.5264-0.4023,0.6992c-0.207,0.1787-0.4395,0.2598-0.6953,0.2422
				c-0.2578-0.0156-0.4727-0.125-0.6445-0.3262c-0.1836-0.2129-0.2637-0.4482-0.2432-0.707
				c0.0205-0.2578,0.1396-0.4785,0.3545-0.6631c0.2412-0.208,0.5059-0.29,0.793-0.248c0.2861,0.042,0.5498,0.2031,0.7891,0.4814
				C50.3269,129.3512,50.4675,130.2496,50.2038,131.4068z M49.6706,128.9801c-0.0332-0.0488-0.0684-0.0957-0.1055-0.1387
				c-0.1826-0.2119-0.3848-0.334-0.6055-0.3652c-0.2217-0.0312-0.4189,0.0283-0.5938,0.1777
				c-0.1582,0.1367-0.248,0.2998-0.2695,0.4912c-0.0195,0.1924,0.0332,0.3623,0.1602,0.5107
				c0.1348,0.1572,0.3008,0.2432,0.502,0.2559c0.1992,0.0137,0.3779-0.0479,0.5361-0.1836
				C49.4988,129.5533,49.6238,129.3043,49.6706,128.9801z"/>
		</g>
		<g>
			<path fill="#231F20" d="M56.6355,133.0709l-2.7188-2.1045l0.1562-0.2021l2.7188,2.1045L56.6355,133.0709z"/>
			<path fill="#231F20" d="M54.4753,135.8609l-1.793-3.373l0.2109-0.1191l1.623,3.0508l1.1465-1.4824l0.1895,0.1455
				L54.4753,135.8609z"/>
		</g>
		<g>
			<path fill="#231F20" d="M61.5437,135.7086l-3.0859-1.5137l0.1133-0.2305l3.0859,1.5137L61.5437,135.7086z"/>
			<path fill="#231F20" d="M59.2136,136.7164c0.3145-0.1797,0.6133-0.2002,0.8945-0.0625c0.2217,0.1094,0.375,0.2852,0.459,0.5264
				c0.084,0.2432,0.0723,0.4736-0.0352,0.6934c-0.1104,0.2246-0.2861,0.3789-0.5264,0.4619
				c-0.2412,0.082-0.4736,0.0693-0.6973-0.041c-0.29-0.1426-0.46-0.3867-0.5078-0.7363c-0.3311,0.2139-0.6602,0.2402-0.9873,0.0801
				c-0.2471-0.1211-0.415-0.3076-0.502-0.5605c-0.0879-0.252-0.0713-0.5,0.0479-0.7441c0.1221-0.248,0.3076-0.416,0.5605-0.5049
				c0.252-0.0898,0.498-0.0752,0.7383,0.043C58.9939,136.0358,59.1785,136.318,59.2136,136.7164z M57.9382,137.4156
				c0.1758,0.0859,0.3574,0.0957,0.543,0.0283c0.1855-0.0664,0.3232-0.1914,0.4131-0.374c0.0869-0.1777,0.0977-0.3613,0.0303-0.5498
				s-0.1914-0.3271-0.3711-0.415c-0.1816-0.0889-0.3662-0.1016-0.5566-0.0371c-0.1895,0.0635-0.3301,0.1875-0.4209,0.3721
				c-0.0908,0.1865-0.1025,0.3721-0.0342,0.5557S57.7429,137.319,57.9382,137.4156z M59.9988,136.8883
				c-0.168-0.083-0.3379-0.0957-0.5098-0.0381c-0.1729,0.0566-0.3008,0.168-0.3828,0.335c-0.082,0.168-0.0918,0.3359-0.0293,0.5029
				s0.1816,0.2949,0.3555,0.3809c0.1641,0.0801,0.332,0.0908,0.5039,0.0332c0.1719-0.0586,0.2988-0.1699,0.3799-0.335
				c0.0791-0.1621,0.0869-0.3291,0.0264-0.5C60.281,137.0963,60.1658,136.9703,59.9988,136.8883z"/>
		</g>
		<g>
			<path fill="#231F20" d="M66.8816,137.3033l-3.3271-0.8613l0.0645-0.248l3.3271,0.8613L66.8816,137.3033z"/>
			<path fill="#231F20" d="M63.0447,138.232l0.2139-0.0898c0.3389,0.8711,0.7812,1.4287,1.3242,1.6738
				c-0.1006-0.3008-0.1211-0.5674-0.0625-0.7959c0.0684-0.2617,0.2129-0.459,0.4346-0.5918
				c0.2207-0.1318,0.4609-0.165,0.7188-0.0986c0.2695,0.0703,0.4697,0.2148,0.5977,0.4365
				c0.1289,0.2197,0.1572,0.4668,0.0869,0.7393c-0.082,0.3164-0.251,0.5391-0.5068,0.6699
				c-0.2549,0.1289-0.5635,0.1475-0.9238,0.0537C64.0994,140.0152,63.4724,139.3492,63.0447,138.232z M64.866,139.9361
				c0.0498,0.0176,0.0977,0.0322,0.1465,0.0449c0.2852,0.0742,0.5264,0.0664,0.7217-0.0244
				c0.1963-0.0918,0.3242-0.2568,0.3867-0.4961c0.0508-0.1973,0.0283-0.3809-0.0664-0.5498
				c-0.0928-0.1689-0.2373-0.2783-0.4307-0.3291c-0.1982-0.0508-0.3789-0.0283-0.5459,0.0684s-0.2754,0.2432-0.3262,0.4404
				C64.6794,139.3697,64.7175,139.652,64.866,139.9361z"/>
		</g>
		<g>
			<path fill="#231F20" d="M71.9236,136.6041l0.3027,0.0146c0.1953,0.2646,0.2861,0.5371,0.2725,0.8174
				c-0.0146,0.2803-0.1221,0.5127-0.3232,0.6982c-0.2021,0.1855-0.4385,0.2715-0.7148,0.2568
				c-0.5449-0.0273-1.2754-0.4863-2.1914-1.377l-0.0811,1.5977l-0.2363-0.0127l0.1104-2.1807
				c0.9678,1.1123,1.7705,1.6846,2.4072,1.7168c0.2119,0.0107,0.3926-0.0537,0.5439-0.1943
				c0.1523-0.1396,0.2334-0.3193,0.2451-0.5371c0.0068-0.1436-0.0156-0.2754-0.0693-0.3926
				C72.1365,136.8941,72.0476,136.7574,71.9236,136.6041z"/>
			<path fill="#231F20" d="M72.3591,140.1832c-0.0156,0.3086-0.1846,0.5605-0.5039,0.7559
				c-0.3193,0.1963-0.7627,0.2793-1.3291,0.251c-0.5273-0.0273-0.9463-0.1523-1.252-0.375
				c-0.3076-0.2236-0.4541-0.4902-0.4385-0.7998c0.0166-0.3242,0.1865-0.582,0.5098-0.7725
				c0.3213-0.1904,0.7383-0.2734,1.2471-0.2471c0.6348,0.0322,1.0908,0.166,1.3701,0.4033
				C72.241,139.6354,72.3738,139.8971,72.3591,140.1832z M69.0779,140.0074c-0.0127,0.2559,0.1201,0.4688,0.4004,0.6387
				c0.2812,0.1709,0.6416,0.2666,1.085,0.2891c0.4326,0.0225,0.7969-0.0352,1.0918-0.1719c0.2949-0.1377,0.4502-0.335,0.4629-0.5918
				c0.0127-0.2422-0.1191-0.4502-0.3945-0.623c-0.2744-0.1738-0.6357-0.2715-1.084-0.2949
				c-0.4531-0.0225-0.8242,0.0361-1.1123,0.1768C69.24,139.5709,69.0906,139.7643,69.0779,140.0074z"/>
		</g>
		<g>
			<path fill="#231F20" d="M77.2302,136.0904l0.2988-0.0459c0.2437,0.2197,0.3877,0.4688,0.4302,0.7461
				c0.0425,0.2764-0.0161,0.5264-0.1753,0.748c-0.1597,0.2227-0.3745,0.3545-0.6479,0.3965c-0.54,0.082-1.3481-0.2207-2.4238-0.9082
				l0.2422,1.5811l-0.2344,0.0352l-0.3306-2.1572c1.1714,0.8945,2.0723,1.293,2.7031,1.1963
				c0.209-0.0322,0.3735-0.1318,0.4946-0.2998c0.1206-0.168,0.1641-0.3594,0.1309-0.5752c-0.022-0.1426-0.0708-0.2666-0.147-0.3701
				C77.4963,136.3316,77.3816,136.2164,77.2302,136.0904z"/>
			<path fill="#231F20" d="M78.3513,139.6412l-3.3984,0.5205l-0.0391-0.2539l3.3984-0.5205L78.3513,139.6412z"/>
		</g>
		<g>
			<path fill="#231F20" d="M82.3269,134.5191l0.2832-0.1055c0.2832,0.166,0.4746,0.3799,0.5723,0.6436s0.0898,0.5195-0.0215,0.7695
				c-0.1113,0.249-0.2969,0.4219-0.5557,0.5176c-0.5117,0.1895-1.3643,0.0557-2.5576-0.4023l0.5557,1.501l-0.2217,0.082
				l-0.7578-2.0479c1.3271,0.6406,2.29,0.8506,2.8887,0.6289c0.1982-0.0742,0.3398-0.2051,0.4238-0.3936
				s0.0879-0.3857,0.0117-0.5898c-0.0488-0.1357-0.1221-0.2471-0.2168-0.333C82.6355,134.7018,82.4997,134.6119,82.3269,134.5191z"
				/>
			<path fill="#231F20" d="M83.2019,136.8824l0.2832-0.1055c0.2832,0.166,0.4746,0.3799,0.5723,0.6436s0.0898,0.5195-0.0215,0.7686
				c-0.1113,0.25-0.2959,0.4229-0.5557,0.5186c-0.5117,0.1895-1.3643,0.0557-2.5571-0.4023l0.5557,1.5l-0.2217,0.082l-0.7583-2.0469
				c1.3276,0.6406,2.29,0.8506,2.8887,0.6289c0.1982-0.0742,0.3398-0.2051,0.4238-0.3936s0.0879-0.3857,0.0127-0.5898
				c-0.0498-0.1357-0.1221-0.2471-0.2178-0.334S83.3757,136.9752,83.2019,136.8824z"/>
		</g>
		<g>
			<path fill="#231F20" d="M86.9988,131.9557l0.2578-0.1602c0.3105,0.1055,0.541,0.2773,0.6895,0.5156s0.1934,0.4902,0.1338,0.7578
				c-0.0596,0.2656-0.2041,0.4727-0.4385,0.6182c-0.4639,0.2891-1.3262,0.3291-2.5859,0.1221l0.8457,1.3574l-0.2012,0.125
				l-1.1543-1.8535c1.4297,0.3613,2.4141,0.3711,2.9551,0.0352c0.1807-0.1133,0.293-0.2695,0.3359-0.4707
				c0.0449-0.2021,0.0098-0.3955-0.1055-0.5811c-0.0762-0.1221-0.1699-0.2168-0.2812-0.2822
				C87.3386,132.0729,87.1882,132.0113,86.9988,131.9557z"/>
			<path fill="#231F20" d="M88.5359,134.1412l0.209-0.1299c0.2305,0.0918,0.4219,0.2568,0.5703,0.4971
				c0.1592,0.2549,0.2207,0.5059,0.1826,0.7539c-0.0361,0.248-0.1621,0.4395-0.376,0.5723
				c-0.1533,0.0957-0.3184,0.1357-0.4941,0.1201c-0.1758-0.0166-0.3447-0.0938-0.5049-0.2334l-0.0088,0.0049
				c0.1094,0.4561-0.0215,0.7998-0.3906,1.0293c-0.2578,0.1611-0.5146,0.2021-0.7715,0.124
				c-0.2578-0.0781-0.4609-0.2363-0.6094-0.4746c-0.1504-0.2422-0.2422-0.4961-0.2754-0.7617l0.2002-0.125
				c0.0322,0.2578,0.1201,0.5029,0.2646,0.7344c0.125,0.2012,0.2832,0.3301,0.4766,0.3838
				c0.1924,0.0537,0.3809,0.0225,0.5664-0.0928c0.1982-0.123,0.3145-0.2891,0.3496-0.4941c0.0352-0.207-0.0225-0.4268-0.1729-0.6592
				l0.2041-0.1279c0.1338,0.2148,0.2969,0.3535,0.4902,0.417s0.3672,0.0459,0.5234-0.0518
				c0.1543-0.0957,0.2451-0.2402,0.2715-0.4336c0.0244-0.1914-0.0215-0.3848-0.1406-0.5742
				C88.9705,134.4108,88.782,134.2506,88.5359,134.1412z"/>
		</g>
		<g>
			<path fill="#231F20" d="M91.0622,128.5006l0.2197-0.209c0.3262,0.041,0.5859,0.1631,0.7793,0.3662
				c0.1934,0.2041,0.2871,0.4424,0.2832,0.7158s-0.1055,0.5039-0.3057,0.6934c-0.3955,0.377-1.2314,0.5898-2.5088,0.6406
				l1.1025,1.1602l-0.1709,0.1621l-1.5039-1.582c1.4717,0.0645,2.4395-0.123,2.9014-0.5625
				c0.1533-0.1455,0.2314-0.3213,0.2344-0.5283c0.0029-0.2061-0.0703-0.3887-0.2207-0.5469c-0.0986-0.1045-0.21-0.1787-0.332-0.2207
				S91.2585,128.5182,91.0622,128.5006z"/>
			<path fill="#231F20" d="M94.3943,131.1119l-1.4131,1.3438l0.3311,0.3477l-0.1494,0.1426l-0.332-0.3477l-0.9609,0.9141
				l-0.1758-0.1855l0.9609-0.9141l-1.0801-1.1367l0.0605-0.0576l2.6934-0.1758L94.3943,131.1119z M92.8054,132.2701l1.0498-0.998
				l-1.8857,0.1191L92.8054,132.2701z"/>
		</g>
		<g>
			<path fill="#231F20" d="M94.3474,124.3024l0.1729-0.249c0.3262-0.0264,0.6064,0.042,0.8369,0.2021
				c0.2295,0.1602,0.3701,0.374,0.4209,0.6426c0.0518,0.2695-0.001,0.5156-0.1582,0.7422
				c-0.3125,0.4482-1.0889,0.8252-2.3291,1.1309l1.3135,0.9141l-0.1357,0.1943l-1.792-1.2471
				c1.4551-0.2324,2.3652-0.6113,2.7305-1.1348c0.1211-0.1738,0.1621-0.3613,0.123-0.5645s-0.1484-0.3672-0.3281-0.4922
				c-0.1172-0.082-0.2402-0.1318-0.3691-0.1484C94.7058,124.275,94.5427,124.2789,94.3474,124.3024z"/>
			<path fill="#231F20" d="M98.1531,126.2555l-0.1367,0.1963l-0.998-0.6943l-0.6211,0.8926c0.0859,0.041,0.166,0.0879,0.2393,0.1387
				c0.2822,0.1963,0.4521,0.4326,0.5146,0.709c0.0586,0.2783-0.002,0.5508-0.1875,0.8164
				c-0.1816,0.2617-0.4209,0.4189-0.7148,0.4707c-0.2949,0.0537-0.5723-0.0117-0.834-0.1934
				c-0.2188-0.1523-0.4014-0.3711-0.5498-0.6572l0.167-0.2412c0.1572,0.3359,0.334,0.5703,0.5293,0.707
				c0.2012,0.1406,0.4141,0.1895,0.6357,0.1484c0.2227-0.041,0.4053-0.1621,0.5449-0.3652
				c0.1533-0.2197,0.2041-0.4394,0.1533-0.6621c-0.0527-0.2207-0.1934-0.4121-0.4238-0.5723
				c-0.125-0.0869-0.2695-0.1562-0.4307-0.209l0.917-1.3164L98.1531,126.2555z"/>
		</g>
		<g>
			<path fill="#231F20" d="M96.7195,119.527l0.1191-0.2793c0.3145-0.0898,0.6025-0.082,0.8604,0.0293s0.4385,0.293,0.542,0.5449
				c0.1045,0.2539,0.1025,0.5059-0.0068,0.7598c-0.2148,0.502-0.8994,1.0273-2.0527,1.5762l1.4697,0.6309l-0.0928,0.2168
				l-2.0068-0.8594c1.3789-0.5215,2.1943-1.0742,2.4453-1.6621c0.084-0.1934,0.0859-0.3867,0.0078-0.5781
				c-0.0791-0.1895-0.2188-0.3281-0.4189-0.4141c-0.1328-0.0566-0.2637-0.082-0.3926-0.0723
				C97.0642,119.4274,96.906,119.4645,96.7195,119.527z"/>
			<path fill="#231F20" d="M100.6677,120.5524l0.0664,0.2266c-0.8809,0.1875-1.4971,0.543-1.8496,1.0645
				c0.293-0.0703,0.5605-0.0508,0.8047,0.0527c0.252,0.1094,0.4268,0.2812,0.5244,0.5195c0.0986,0.2363,0.0957,0.4785-0.0098,0.7227
				c-0.1104,0.2578-0.2861,0.4336-0.5273,0.5293c-0.2402,0.0938-0.4912,0.0859-0.752-0.0273
				c-0.292-0.125-0.4824-0.3262-0.5713-0.6016s-0.0605-0.584,0.085-0.9219C98.7693,121.3453,99.5124,120.8238,100.6677,120.5524z
				 M98.7244,122.0973c-0.0293,0.0527-0.0557,0.1055-0.0781,0.1582c-0.1104,0.2559-0.1299,0.4902-0.0605,0.7031
				s0.209,0.3633,0.4209,0.4551c0.1914,0.082,0.377,0.0898,0.5586,0.0254c0.1826-0.0664,0.3115-0.1895,0.3887-0.3691
				c0.082-0.1895,0.085-0.377,0.0088-0.5625s-0.21-0.3184-0.4014-0.4004C99.3152,122.0016,99.0349,121.9977,98.7244,122.0973z"/>
		</g>
		<g>
			<path fill="#231F20" d="M98.0808,114.3717l0.0605-0.2969c0.291-0.1523,0.5742-0.2012,0.8496-0.1445
				c0.2744,0.0566,0.4883,0.1982,0.6406,0.4248s0.2012,0.4746,0.1465,0.7451c-0.1104,0.5352-0.6748,1.1875-1.6943,1.958
				l1.5674,0.3223l-0.0479,0.2314l-2.1377-0.4395c1.2451-0.7891,1.9316-1.4941,2.0605-2.1191
				c0.043-0.208,0.0059-0.3965-0.1094-0.5684c-0.1162-0.1709-0.2803-0.2783-0.4941-0.3223
				c-0.1416-0.0293-0.2744-0.0273-0.3984,0.0088C98.3992,114.2057,98.2517,114.2731,98.0808,114.3717z"/>
			<path fill="#231F20" d="M102.7878,114.7565l-2.2402,3.0947l-0.1992-0.1367l2.0234-2.7998l-1.8359-0.3779l0.0488-0.2334
				L102.7878,114.7565z"/>
		</g>
	</g>
</g>
	<g id="Weekday-ring_A-06">
		<path fill="#FFFFFF" d="M71.9778,85.1762c-13.6984,0-24.8032,11.1048-24.8032,24.8031s11.1048,24.8032,24.8032,24.8032
			s24.8031-11.1048,24.8031-24.8031S85.6763,85.1762,71.9778,85.1762z M71.9778,120.6091c-5.8707,0-10.6299-4.7592-10.6299-10.6299
			s4.7592-10.6299,10.6299-10.6299s10.6299,4.7592,10.6299,10.6299S77.8486,120.6091,71.9778,120.6091z"/>
		<g>
			<g>
				<g>
					<path fill="#231F20" d="M85.4297,109.7305l1.3057-1.5967h0.2695v3.4375h-0.2686v-3.0488l-1.3076,1.6074l-1.3135-1.6074v3.0488
						h-0.2656v-3.4375h0.2656L85.4297,109.7305z"/>
					<path fill="#231F20" d="M89.4678,108.0894c0.5088,0,0.9395,0.1714,1.293,0.5132c0.3535,0.3423,0.5303,0.7593,0.5303,1.2515
						c0,0.4907-0.1768,0.9067-0.5303,1.2485s-0.7842,0.5137-1.293,0.5137c-0.5068,0-0.9365-0.1719-1.2881-0.5137
						c-0.3525-0.3418-0.5283-0.7578-0.5283-1.2485c0-0.4922,0.1758-0.9092,0.5283-1.2515
						C88.5312,108.2607,88.9609,108.0894,89.4678,108.0894z M89.4775,111.3701c0.4277,0,0.7891-0.1465,1.084-0.4395
						s0.4414-0.6519,0.4414-1.0767c0-0.4263-0.1465-0.7861-0.4414-1.0791s-0.6562-0.4395-1.084-0.4395
						c-0.4297,0-0.7939,0.1465-1.0918,0.4395s-0.4463,0.6528-0.4463,1.0791c0,0.4248,0.1484,0.7837,0.4463,1.0767
						S89.0479,111.3701,89.4775,111.3701z"/>
					<path fill="#231F20" d="M95.0371,108.1338v3.4375h-0.2188l-2.6143-3.0044v3.0044h-0.2656v-3.4375h0.2256l2.6074,3.0049v-3.0049
						H95.0371z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M83.1055,102.5801l1.3945,2.8984l1.5332-0.7383l0.0957,0.1997l-1.7715,0.853l-1.4922-3.0977
						L83.1055,102.5801z"/>
					<path fill="#231F20" d="M87.2812,100.5693l0.2383-0.1152l0.8145,1.6899c0.2227,0.4624,0.2734,0.8774,0.1543,1.2451
						c-0.1211,0.3667-0.3711,0.6431-0.7539,0.8271s-0.752,0.209-1.1133,0.0771c-0.3594-0.1323-0.6445-0.4146-0.8516-0.8462
						l-0.8418-1.7451l0.2422-0.1162l0.8359,1.7363c0.1777,0.3691,0.416,0.6113,0.7109,0.7251
						c0.2969,0.1147,0.5996,0.0972,0.9102-0.0527c0.3145-0.1509,0.5176-0.3784,0.6133-0.6836
						c0.0938-0.3052,0.0469-0.6514-0.1387-1.0386L87.2812,100.5693z"/>
					<path fill="#231F20" d="M90.9551,98.7998l1.4922,3.0977l-0.1973,0.0947l-3.6602-1.5728l1.3047,2.7075l-0.2402,0.1152
						l-1.4902-3.0977l0.2031-0.0977l3.6523,1.5762l-1.3047-2.708L90.9551,98.7998z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M80.4375,96.4268l0.1738,0.1382l-0.8047,1.0088l2.5146,2.0054l-0.167,0.209l-2.5146-2.0054
						l-0.8037,1.0088l-0.1738-0.1382L80.4375,96.4268z"/>
					<path fill="#231F20" d="M82.2803,94.1162l0.165-0.2075l1.4668,1.1694c0.4004,0.3198,0.627,0.6714,0.6787,1.0547
						c0.0518,0.3828-0.0557,0.7407-0.3193,1.0728c-0.2646,0.3315-0.5879,0.5146-0.9707,0.5522
						c-0.3809,0.0371-0.7598-0.0933-1.1348-0.3921l-1.5137-1.2075l0.167-0.21l1.5068,1.2012
						c0.3203,0.2559,0.6387,0.3711,0.9551,0.3447c0.3164-0.0249,0.582-0.1724,0.7969-0.4419
						c0.2168-0.272,0.3008-0.5659,0.2539-0.8813c-0.0469-0.3164-0.2383-0.6084-0.5742-0.876L82.2803,94.1162z"/>
					<path fill="#231F20" d="M84.0664,91.8765l0.1738,0.1382l-1.0039,1.2588l1.0742,0.8574l0.9785-1.2261l0.1758,0.1401
						l-0.9785,1.2261l1.0908,0.8696l1.0283-1.2896l0.1738,0.1382l-1.1943,1.4971l-2.6885-2.1436L84.0664,91.8765z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M74.9238,95.9775l-1.2666-1.6279l0.0605-0.2627l3.3516,0.7646l-0.0596,0.2617l-2.9727-0.6782
						l1.2764,1.6323l-1.8604,0.9233l2.9736,0.6782l-0.0596,0.2588l-3.3516-0.7646l0.0586-0.2588L74.9238,95.9775z"/>
					<path fill="#231F20" d="M74.1709,91.9893l3.7295-0.7793l-0.0615,0.2725l-1.2803,0.2661l-0.374,1.6387l1.0381,0.7925
						l-0.0615,0.2725l-3.0225-2.3203L74.1709,91.9893z M76.3203,91.7983l-1.7432,0.3613l1.4141,1.0801L76.3203,91.7983z"/>
					<path fill="#231F20" d="M74.6406,90.0405l0.1963-0.8584c0.082-0.3599,0.2236-0.6177,0.4229-0.7725s0.4316-0.2017,0.6973-0.1411
						c0.3867,0.0884,0.6104,0.3628,0.6699,0.8242c0.0781-0.0986,0.2822-0.2085,0.6133-0.3301l1.332-0.4932l-0.0703,0.3066
						l-1.0518,0.3745c-0.3516,0.1245-0.5781,0.2329-0.6787,0.3237c-0.1016,0.0913-0.1758,0.2417-0.2236,0.4512l-0.1035,0.4541
						l1.6084,0.3672l-0.0596,0.2588L74.6406,90.0405z M74.917,89.8311l1.3125,0.2993l0.127-0.5571
						c0.0645-0.2827,0.0566-0.5127-0.0244-0.688c-0.0801-0.1763-0.2246-0.2871-0.4346-0.335
						c-0.2061-0.0474-0.3838-0.0083-0.5332,0.1177c-0.1504,0.126-0.2578,0.3311-0.3232,0.6157L74.917,89.8311z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M67.5444,96.2979l3.0854,0.4775l0.0161,0.0693l-3.0781,2.1221l-0.0605-0.2656l2.5273-1.7451
						l-3.0376-0.4902l-0.0181-0.0801l2.5249-1.7549l-3.0347-0.4785l-0.0605-0.2656l3.6943,0.5801l0.0137,0.0615L67.5444,96.2979z"/>
					<path fill="#231F20" d="M65.9038,91.6748l0.2158-0.0498l0.3584,1.5703l1.3408-0.3066l-0.3486-1.5283l0.2188-0.0498
						l0.3486,1.5283l1.3599-0.3096l-0.3667-1.6084l0.2163-0.0498l0.4263,1.8672l-3.3525,0.7656L65.9038,91.6748z"/>
					<path fill="#231F20" d="M65.7725,91.0996l-0.2681-1.1738c-0.1353-0.5938-0.0825-1.082,0.1577-1.4648
						c0.2407-0.3848,0.6079-0.6338,1.1021-0.7461c0.4844-0.1104,0.9204-0.0469,1.3076,0.1904
						c0.3857,0.2373,0.6445,0.6416,0.7744,1.21l0.2783,1.2188L65.7725,91.0996z M65.9292,90.791l2.9199-0.666l-0.2158-0.9453
						c-0.0991-0.4336-0.3145-0.7646-0.647-0.9922c-0.332-0.2285-0.7178-0.292-1.1577-0.1914
						c-0.4307,0.0977-0.749,0.3203-0.9561,0.668c-0.207,0.3467-0.2583,0.7461-0.1553,1.1982L65.9292,90.791z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M62.0083,97.9004l-2.0625-0.0244l-0.168-0.2109l2.6875-2.1436l0.1675,0.21l-2.3838,1.9014
						l2.0723,0.0195l-0.438,2.0293l2.3838-1.9004l0.1655,0.207l-2.6875,2.1436l-0.1655-0.208L62.0083,97.9004z"/>
					<path fill="#231F20" d="M59.1235,96.8438l2.6875-2.1426l0.1655,0.207l-2.6875,2.1436L59.1235,96.8438z"/>
					<path fill="#231F20" d="M57.4595,94.7578l0.1733-0.1387l1.0039,1.2598l1.0752-0.8574l-0.978-1.2266l0.1753-0.1406l0.978,1.2266
						l1.0903-0.8691l-1.0283-1.29l0.1733-0.1377l1.1938,1.4961l-2.6875,2.1445L57.4595,94.7578z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M57.4082,105.0439l0.0967-0.2002l1.1621,0.5605l1.3955-2.8984l0.2412,0.1162l-1.3955,2.8975
						l1.1621,0.5605l-0.0967,0.1992L57.4082,105.0439z"/>
					<path fill="#231F20" d="M54.4814,103.6348l1.4922-3.0977l0.2422,0.1162l-0.707,1.4678l2.0669,0.9951l0.7065-1.4678
						l0.2393,0.1152l-1.4912,3.0977l-0.2393-0.1152l0.6885-1.4297l-2.0669-0.9961l-0.689,1.4307L54.4814,103.6348z"/>
					<path fill="#231F20" d="M51.4795,102.1885l-0.2393-0.1152l0.814-1.6895c0.2227-0.4629,0.5151-0.7617,0.8774-0.8975
						c0.3618-0.1348,0.7339-0.1104,1.1167,0.0742c0.3818,0.1836,0.6323,0.458,0.7544,0.8223
						c0.1216,0.3633,0.0781,0.7617-0.1299,1.1934l-0.8398,1.7461l-0.2422-0.1172l0.8359-1.7363
						c0.1777-0.3691,0.2192-0.7051,0.1235-1.0078c-0.0952-0.3027-0.2983-0.5293-0.6089-0.6787
						c-0.3125-0.1514-0.6182-0.168-0.9155-0.0518c-0.2979,0.1162-0.5396,0.3682-0.7261,0.7549L51.4795,102.1885z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M57.3916,111.8652v-3.438c0-0.3789,0.0723-0.6406,0.2148-0.7852
						c0.1426-0.144,0.3115-0.2163,0.5068-0.2163c0.0459,0,0.0986,0.0029,0.1602,0.0098l0.0244,0.251
						c-0.0557-0.0132-0.1084-0.0195-0.1572-0.0195c-0.3223,0-0.4824,0.2295-0.4824,0.689v3.5093H57.3916z"/>
					<path fill="#231F20" d="M54.0889,111.8652h-0.2656v-1.8755c0-0.5132,0.1338-0.9097,0.4014-1.1885s0.6133-0.4185,1.0381-0.4185
						c0.4238,0,0.7686,0.1382,1.0361,0.4136s0.4014,0.6528,0.4014,1.1318v1.937h-0.2686v-1.9268
						c0-0.4102-0.1084-0.731-0.3262-0.9624c-0.2168-0.2314-0.498-0.3472-0.8428-0.3472c-0.3477,0-0.6299,0.1172-0.8477,0.3506
						c-0.2178,0.2339-0.3262,0.5659-0.3262,0.9956V111.8652z"/>
					<path fill="#231F20" d="M51.2236,111.8652v-0.2217h1.6104v-1.3755h-1.5684v-0.2241h1.5684v-1.395h-1.6494v-0.2217h1.915v3.438
						H51.2236z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M57.9102,118.8564l-0.0967-0.2002l1.3545-0.6523l-0.5664-1.1768l-1.2227,0.5889l-0.0957-0.2002
						l1.2227-0.5889l-0.7324-1.5205l0.2383-0.1152l1.4922,3.0977L57.9102,118.8564z"/>
					<path fill="#231F20" d="M57.5117,119.0488l-0.7939,0.3818c-0.333,0.1602-0.6221,0.21-0.8672,0.1504
						c-0.2451-0.0586-0.4268-0.2109-0.5449-0.457c-0.1729-0.3574-0.0967-0.7031,0.2256-1.0371
						c-0.125,0.001-0.3379-0.0908-0.6396-0.2744l-1.2158-0.7324l0.2832-0.1367l0.9492,0.5889
						c0.3164,0.1973,0.542,0.3066,0.6758,0.3281c0.1348,0.0225,0.2988-0.0127,0.4922-0.1064l0.4199-0.2021l-0.7158-1.4854
						l0.2393-0.1152L57.5117,119.0488z M57.1758,118.9639l-0.584-1.2129l-0.5146,0.248c-0.2617,0.126-0.4365,0.2754-0.5234,0.4473
						c-0.0879,0.1729-0.085,0.3555,0.0088,0.5488c0.0918,0.1904,0.2334,0.3057,0.4248,0.3447
						c0.1924,0.0381,0.4189-0.0059,0.6826-0.1328L57.1758,118.9639z"/>
					<path fill="#231F20" d="M54.6738,120.415l-1.4922-3.0977l0.2402-0.1152l1.4912,3.0977L54.6738,120.415z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M62.752,124.5879l-1.8154-3.293l0.0479-0.0605l3.6172,1.0342l-0.168,0.2109l-3.0332-0.8623
						l1.5195,2.7598L62.752,124.5879z"/>
					<path fill="#231F20" d="M62.332,125.1143l-2.6875-2.1436l0.166-0.208l2.6875,2.1436L62.332,125.1143z"/>
					<path fill="#231F20" d="M60.668,127.2012l-0.1729-0.1387l1.0039-1.2588l-1.0752-0.8574l-0.9785,1.2256l-0.1748-0.1396
						l0.9775-1.2256l-1.0898-0.8701l-1.0293,1.29l-0.1729-0.1387l1.1943-1.498l2.6875,2.1445L60.668,127.2012z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M70.2217,125.3984l-0.2861-0.0654c0.2383-0.252,0.3809-0.4834,0.4287-0.6924
						c0.0459-0.2021,0.0225-0.3828-0.0684-0.5459c-0.0918-0.1641-0.2275-0.2656-0.4082-0.3066
						c-0.1299-0.0293-0.2559-0.0166-0.3779,0.0391c-0.1221,0.0566-0.2598,0.2002-0.4141,0.4326
						c-0.1543,0.2334-0.2773,0.4004-0.3672,0.5029c-0.0908,0.1025-0.2061,0.1797-0.3467,0.2344
						c-0.1396,0.0527-0.3066,0.0576-0.5,0.0137c-0.2578-0.0586-0.4541-0.2021-0.5879-0.4316
						c-0.1348-0.2305-0.1709-0.4795-0.1084-0.752c0.0625-0.2783,0.2266-0.542,0.4883-0.792l0.3047,0.0693
						c-0.3125,0.2705-0.4961,0.5244-0.5508,0.7637c-0.0449,0.1973-0.0186,0.3799,0.0791,0.5459s0.2393,0.2705,0.4268,0.3125
						c0.1426,0.0332,0.2803,0.0205,0.415-0.0381c0.1328-0.0586,0.2793-0.2061,0.4375-0.4434c0.1582-0.2354,0.2803-0.4023,0.3672-0.5
						s0.1943-0.1719,0.3252-0.2246c0.1299-0.0508,0.2842-0.0566,0.4609-0.0156c0.2461,0.0557,0.4346,0.1982,0.5654,0.4258
						c0.1299,0.2285,0.166,0.4756,0.1045,0.7412C70.5508,124.9326,70.4209,125.1748,70.2217,125.3984z"/>
					<path fill="#231F20" d="M69.9453,127.4941l-3.7295,0.7793l0.0615-0.2715l1.2803-0.2666l0.374-1.6387l-1.0381-0.792
						l0.0615-0.2725l3.0225,2.3203L69.9453,127.4941z M67.7959,127.6855l1.7432-0.3613l-1.4141-1.0801L67.7959,127.6855z"/>
					<path fill="#231F20" d="M69.0381,131.3574l-0.2158-0.0488l0.2871-1.2578l-3.1367-0.7158l0.0596-0.2607l3.1357,0.7158
						l0.2871-1.2578l0.2168,0.0488L69.0381,131.3574z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M77.0469,124.5029l-0.2861,0.0654c0.1045-0.3301,0.1338-0.6006,0.085-0.8096
						c-0.0449-0.2021-0.1445-0.3555-0.2979-0.4629s-0.3203-0.1406-0.501-0.0996c-0.1289,0.0293-0.2383,0.0967-0.3232,0.2002
						c-0.085,0.1045-0.1475,0.293-0.1855,0.5693c-0.0381,0.2773-0.0762,0.4805-0.1123,0.6113
						c-0.0371,0.1318-0.1074,0.252-0.2109,0.3613s-0.251,0.1865-0.4443,0.2305c-0.2578,0.0586-0.4971,0.0137-0.7178-0.1338
						c-0.2207-0.1494-0.3613-0.3584-0.4238-0.6309c-0.0635-0.2773-0.0312-0.5869,0.0967-0.9248l0.3047-0.0703
						c-0.1641,0.3789-0.2197,0.6875-0.165,0.9268c0.0449,0.1982,0.1484,0.3506,0.3086,0.458
						c0.1602,0.1064,0.333,0.1396,0.5205,0.0967c0.1416-0.0322,0.2607-0.1035,0.3564-0.2139
						c0.0947-0.1113,0.1621-0.3086,0.2031-0.5898c0.0391-0.2812,0.0771-0.4844,0.1133-0.6094
						c0.0352-0.126,0.0996-0.2402,0.1953-0.3438c0.0947-0.1025,0.2305-0.1748,0.4082-0.2148
						c0.2461-0.0566,0.4775-0.0107,0.6943,0.1387c0.2158,0.1484,0.3555,0.3564,0.416,0.6221
						C77.1406,123.9404,77.1289,124.2148,77.0469,124.5029z"/>
					<path fill="#231F20" d="M77.707,126.5107l-3.0225,2.3203l-0.0615-0.2715l1.0371-0.7949l-0.374-1.6387l-1.2793-0.2637
						l-0.0615-0.2734l3.7285,0.7803L77.707,126.5107z M75.8535,127.6162l1.4141-1.082l-1.7422-0.3594L75.8535,127.6162z"/>
					<path fill="#231F20" d="M78.1299,128.4756l0.1592,0.6992c0.084,0.3652,0.0703,0.6602-0.04,0.8848
						c-0.1104,0.2236-0.3018,0.3662-0.5713,0.4277c-0.3232,0.0742-0.6084-0.0293-0.8555-0.3115
						c0.0059,0.543-0.2188,0.8652-0.6729,0.9688c-0.2725,0.0615-0.5117,0.0107-0.7178-0.1553
						c-0.207-0.165-0.3506-0.4219-0.4297-0.7676l-0.2236-0.9805L78.1299,128.4756z M76.418,129.1387l-1.3643,0.3115l0.1582,0.6943
						c0.0654,0.2861,0.1768,0.4893,0.333,0.6104c0.1572,0.1201,0.3389,0.1582,0.5449,0.1104
						c0.458-0.1045,0.6113-0.4873,0.4609-1.1455L76.418,129.1387z M77.9727,128.7842l-1.3359,0.3047l0.082,0.3604
						c0.1396,0.6104,0.4316,0.8643,0.876,0.7627c0.4463-0.1025,0.5986-0.4609,0.458-1.0771L77.9727,128.7842z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M82.4121,120.3418l-0.2285,0.1836c-0.0488-0.3438-0.1396-0.5996-0.2734-0.7676
						c-0.1289-0.1621-0.2852-0.2559-0.4707-0.2871c-0.1846-0.0293-0.3496,0.0137-0.4941,0.1289
						c-0.1035,0.082-0.1719,0.1895-0.2041,0.3203c-0.0322,0.1289-0.0059,0.3281,0.0791,0.5918
						c0.0869,0.2676,0.1406,0.4668,0.1641,0.6016s0.0127,0.2734-0.0322,0.416c-0.0459,0.1426-0.1455,0.2773-0.3018,0.4004
						c-0.2061,0.1641-0.4404,0.2285-0.7031,0.1914c-0.2637-0.0391-0.4824-0.166-0.6562-0.3848
						c-0.1777-0.2227-0.2832-0.5156-0.3145-0.875l0.2441-0.1953c0.0176,0.4121,0.1006,0.7148,0.2539,0.9062
						c0.126,0.1582,0.2852,0.252,0.4766,0.2793c0.1904,0.0254,0.3604-0.0195,0.5107-0.1406
						c0.1143-0.0898,0.1904-0.2051,0.2275-0.3477c0.0381-0.1406,0.0137-0.3457-0.0723-0.6172s-0.1406-0.4707-0.1621-0.5996
						c-0.0234-0.1289-0.0137-0.2598,0.0273-0.3945c0.04-0.1328,0.1318-0.2578,0.2734-0.3711
						c0.1982-0.1562,0.4258-0.2168,0.6855-0.1758s0.4756,0.168,0.6455,0.3809C82.2539,119.7949,82.3623,120.0469,82.4121,120.3418z"
						/>
					<path fill="#231F20" d="M84.5947,122.8008l0.165,0.209l-1.4658,1.1699c-0.4014,0.3184-0.7939,0.4609-1.1797,0.4258
						c-0.3838-0.0352-0.71-0.2188-0.9736-0.5508c-0.2646-0.3301-0.3711-0.6875-0.3223-1.0664
						c0.0479-0.3828,0.2598-0.7227,0.6338-1.0215l1.5146-1.207l0.167,0.2109l-1.5068,1.2012
						c-0.3203,0.2559-0.5039,0.541-0.5488,0.8535c-0.0449,0.3145,0.0391,0.6074,0.2539,0.877
						c0.2168,0.2715,0.4844,0.418,0.8027,0.4434s0.6465-0.0977,0.9824-0.3652L84.5947,122.8008z"/>
					<path fill="#231F20" d="M87.1367,125.9902l-2.6875,2.1426l-0.1357-0.1699l0.7188-3.918l-2.3486,1.873l-0.166-0.207
						l2.6875-2.1426l0.1406,0.1758l-0.7227,3.9121l2.3486-1.873L87.1367,125.9902z"/>
				</g>
			</g>
			<g>
				<g>
					<path fill="#231F20" d="M83.5664,113.5l1.084,0.5225c0.5488,0.2637,0.8975,0.6094,1.0469,1.0371
						c0.1514,0.4277,0.1152,0.8691-0.1035,1.3262c-0.2168,0.4482-0.5371,0.748-0.9648,0.9033
						c-0.4258,0.1533-0.9023,0.1045-1.4297-0.1494l-1.125-0.542L83.5664,113.5z M83.709,113.8145l-1.2988,2.6982l0.873,0.4209
						c0.4004,0.1934,0.793,0.2314,1.1797,0.1133c0.3848-0.1182,0.6758-0.3799,0.8711-0.7861
						c0.1914-0.3975,0.2148-0.7852,0.0723-1.1641c-0.1406-0.3779-0.4219-0.667-0.8398-0.8682L83.709,113.8145z"/>
					<path fill="#231F20" d="M88.4541,115.8047c0.458,0.2207,0.7725,0.5625,0.9424,1.0234
						c0.1699,0.4619,0.1484,0.9141-0.0654,1.3574c-0.2129,0.4424-0.5527,0.7402-1.0205,0.8955
						c-0.4668,0.1543-0.9287,0.1221-1.3867-0.0986c-0.457-0.2197-0.7695-0.5605-0.9375-1.0215
						c-0.1699-0.4609-0.1475-0.9121,0.0654-1.3545c0.2139-0.4434,0.5527-0.7432,1.0186-0.8984
						C87.5352,115.5527,87.9971,115.585,88.4541,115.8047z M87.0391,118.7646c0.3848,0.1855,0.7754,0.2109,1.168,0.0742
						c0.3926-0.1357,0.6797-0.3955,0.8643-0.7783c0.1846-0.3838,0.21-0.7715,0.0713-1.1641
						c-0.1387-0.3916-0.4004-0.6807-0.7871-0.8662c-0.3867-0.1865-0.7783-0.2119-1.1738-0.0781
						c-0.3965,0.1357-0.6855,0.3955-0.8701,0.7793c-0.1846,0.3828-0.2061,0.7705-0.0654,1.1641
						C86.3877,118.2881,86.6523,118.5781,87.0391,118.7646z"/>
					<path fill="#231F20" d="M91.3867,119.0381l1.8691-0.8711l0.2441,0.1162l-1.4922,3.0977l-0.2422-0.1162l1.3223-2.748
						l-1.875,0.8809l-0.4863-2.0176l-1.3223,2.7471l-0.2402-0.1152l1.4922-3.0977l0.2402,0.1152L91.3867,119.0381z"/>
				</g>
			</g>
		</g>
	</g>
</g>
<g id="Dial_A-06">
	<path fill="#FFFFFF" stroke="#231F20" stroke-width="0.1" d="M118.8551,110.0079c0,25.8313-20.9404,46.7717-46.7717,46.7717s-46.7717-20.9404-46.7717-46.7717
		s20.9404-46.7717,46.7717-46.7717S118.8551,84.1767,118.8551,110.0079L118.8551,110.0079z M72.0834,107.7036
		c-1.2727,0-2.3044,1.0317-2.3044,2.3044s1.0317,2.3044,2.3044,2.3044s2.3044-1.0317,2.3044-2.3044l0,0
		C74.3878,108.7353,73.3561,107.7036,72.0834,107.7036z M104.8234,107.1723h-7.6536v5.6693h7.6536V107.1723L104.8234,107.1723z
		 M82.7134,107.1582v5.699h13.4648v-5.699H82.7134z"/>
	<g id="Dial_ring">
    <linearGradient id="Dial_ring-2_1_A-06" gradientUnits="userSpaceOnUse" x1="95.4708" y1="454.7053" x2="48.696" y2="535.7216" gradientTransform="matrix(1 0 0 1 0 -385.2055)">
			<stop  offset="0" style="stop-color:whitesmoke"/>
			<stop  offset="1" style="stop-color:#FFFFFF"/>
		</linearGradient>
		<path id="Dial_ring-2" fill="url(#Dial_ring-2_1_A-06)" stroke="#B3B4B7" stroke-width="0.0133" stroke-miterlimit="1" d="
			M118.8504,110.0079c0,25.8287-20.9383,46.767-46.767,46.767s-46.767-20.9383-46.767-46.767s20.9383-46.767,46.767-46.767
			S118.8504,84.1793,118.8504,110.0079L118.8504,110.0079z M72.0834,68.9097c-22.698,0-41.0983,18.4003-41.0983,41.0983
			s18.4003,41.0983,41.0983,41.0983s41.0983-18.4003,41.0983-41.0983l0,0c0.0001-22.6979-18.4002-41.0983-41.0981-41.0983
			C72.0835,68.9096,72.0834,68.9096,72.0834,68.9097z"/>
    <circle id="Outer_shoulder" fill="none" stroke="#B3B4B7" stroke-width="0.0333" stroke-miterlimit="10" cx="72.0834" cy="110.0079" r="46.767"/>
    <circle id="Inner_shoulder" fill="none" stroke="#767779" stroke-width="0.0333" stroke-miterlimit="1" cx="72.0834" cy="110.0079" r="41.0982"/>
	</g>
	<g id="Sec_v3_">
		<g id="Sec-Ticks">

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.3707" y1="64.8528" x2="67.6468" y2="67.4713"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6819" y1="65.5961" x2="63.2295" y2="68.1706"/>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.0949" y1="66.8251" x2="58.9087" y2="69.3289"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1311" y1="153.1075" x2="85.3173" y2="150.6035"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6627" y1="68.5257" x2="54.7343" y2="70.9317"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5627" y1="151.4059" x2="89.4931" y2="149.0011"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.451" y1="73.267" x2="46.9979" y2="75.3973"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.7757" y1="146.6647" x2="97.2282" y2="144.5338"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7616" y1="76.2551" x2="43.5234" y2="78.2118"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4664" y1="143.6754" x2="100.704" y2="141.7202"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.4032" y1="79.6125" x2="40.3609" y2="81.3743"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8222" y1="140.3176" x2="103.8664" y2="138.5553"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.4165" y1="83.3018" x2="37.5454" y2="84.8502"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8115" y1="136.6275" x2="106.68" y2="135.08"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6733" y1="91.5145" x2="33.0789" y2="92.5858"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5528" y1="128.416" x2="111.1478" y2="127.3439"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9725" y1="95.9474" x2="31.4764" y2="96.7612"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2542" y1="123.9834" x2="112.7503" y2="123.1685"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7425" y1="100.5332" x2="30.3194" y2="101.0804"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4828" y1="119.3963" x2="113.9067" y2="118.8481"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.0003" y1="105.2231" x2="29.6188" y2="105.498"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2251" y1="114.7065" x2="114.6079" y2="114.4314"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.0003" y1="114.7056" x2="29.6188" y2="114.4308"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="117.2251" y1="105.2231" x2="114.6079" y2="105.498"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="27.7425" y1="119.3953" x2="30.3194" y2="118.8481"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="116.4809" y1="100.5342" x2="113.9067" y2="101.0804"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="28.9712" y1="123.9814" x2="31.4751" y2="123.1685"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="115.2522" y1="95.9474" x2="112.7503" y2="96.7603"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="30.6733" y1="128.4139" x2="33.0782" y2="127.3439"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="113.5528" y1="91.5145" x2="111.1478" y2="92.5849"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="35.4146" y1="136.627" x2="37.5454" y2="135.0795"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="108.8096" y1="83.3018" x2="106.68" y2="84.8491"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="38.4013" y1="140.3176" x2="40.3589" y2="138.5553"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="105.8222" y1="79.6115" x2="103.8645" y2="81.3733"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="41.7597" y1="143.674" x2="43.5214" y2="141.7184"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="102.4646" y1="76.2549" x2="100.7029" y2="78.2106"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="45.4495" y1="146.6629" x2="46.9971" y2="144.5322"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="98.7739" y1="73.2659" x2="97.2264" y2="75.3951"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="53.6612" y1="151.4043" x2="54.7329" y2="148.9993"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="90.5628" y1="68.5245" x2="89.4912" y2="70.9296"/>
			</g>
			<g>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="58.0942" y1="153.1057" x2="58.908" y2="150.6019"/>

					<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="86.1299" y1="66.8232" x2="85.3161" y2="69.3267"/>
			</g>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5441" y1="65.5941" x2="80.996" y2="68.169"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8533" y1="64.8509" x2="76.5773" y2="67.4694"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="67.3707" y1="155.1629" x2="67.6468" y2="152.5444"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="62.6819" y1="154.4196" x2="63.2295" y2="151.8452"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="81.5441" y1="154.4216" x2="80.996" y2="151.8467"/>

				<line fill="none" stroke="#231F20" stroke-width="0.1093" stroke-miterlimit="10" x1="76.8533" y1="155.1648" x2="76.5773" y2="152.5463"/>
		</g>
		<g id="Indices">

				<rect x="70.0932" y="64.6429" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9505" height="2.6335"/>

				<rect x="70.0932" y="152.741" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="3.9505" height="2.6328"/>

				<rect x="26.7035" y="108.0329" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6321" height="3.9505"/>

				<rect x="114.798" y="108.0329" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6341" height="3.9505"/>

				<rect x="48.7716" y="70.5428" transform="matrix(0.8659 -0.5002 0.5002 0.8659 -29.2278 34.6902)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6334" height="2.6327"/>

				<rect x="92.8195" y="146.8392" transform="matrix(0.8662 -0.4997 0.4997 0.8662 -61.4381 66.8631)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.633" height="2.634"/>

				<rect x="32.6483" y="86.6703" transform="matrix(0.4997 -0.8662 0.8662 0.4997 -59.2216 73.4405)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6335" height="2.6336"/>

				<rect x="108.945" y="130.7173" transform="matrix(0.5006 -0.8657 0.8657 0.5006 -59.2341 161.3911)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6337" height="2.6337"/>

				<rect x="32.6444" y="130.7114" transform="matrix(0.8662 -0.4996 0.4996 0.8662 -61.4218 34.6275)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6333" height="2.6331"/>

				<rect x="108.9369" y="86.6668" transform="matrix(0.8661 -0.4998 0.4998 0.8661 -29.216 66.8852)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6344" height="2.6331"/>

				<rect x="48.775" y="146.8368" transform="matrix(0.4999 -0.8661 0.8661 0.4999 -103.2627 117.476)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6325" height="2.633"/>

				<rect x="92.8186" y="70.5464" transform="matrix(0.5002 -0.8659 0.8659 0.5002 -15.1781 117.4296)" fill="#FFFFFF" stroke="#231F20" stroke-width="0.1456" stroke-miterlimit="10" width="2.6341" height="2.6331"/>
		</g>
		<g>
			<g>
				<path fill="#231F20" d="M59.9207,147.2793l-0.1-0.1162c-0.0523-0.0564-0.0931-0.1225-0.12-0.1945
					c-0.0179-0.0572-0.017-0.1185,0.0024-0.1752c0.0244-0.0841,0.0848-0.1531,0.1651-0.1882
					c0.0863-0.036,0.183-0.0376,0.2705-0.0046c0.0937,0.0298,0.176,0.0875,0.2358,0.1655l-0.0607,0.1854
					c-0.0451-0.0959-0.1266-0.1697-0.2265-0.2051c-0.0459-0.0172-0.0961-0.0193-0.1433-0.0059
					c-0.0391,0.01-0.0703,0.0395-0.0825,0.078c-0.0113,0.0357-0.009,0.0743,0.0066,0.1084c0.0228,0.0492,0.0536,0.0943,0.091,0.1336
					l0.1,0.1143c0.1044,0.0988,0.1451,0.2476,0.1055,0.3858c-0.0244,0.0852-0.0845,0.1558-0.1647,0.1935
					c-0.0846,0.0371-0.1803,0.0397-0.2668,0.0073c-0.1117-0.0356-0.2083-0.1075-0.2745-0.2043l0.068-0.2075
					c0.0361,0.1244,0.1297,0.2239,0.2517,0.2676c0.0457,0.017,0.096,0.0167,0.1415-0.0008c0.0411-0.015,0.0729-0.0483,0.0861-0.09
					C60.0225,147.4348,59.9902,147.3412,59.9207,147.2793z"/>
				<path fill="#231F20" d="M62.0462,147.1906l0.1648,0.0478l-0.8016,1.0229l-0.0362-0.0107l-0.1053-1.0469l-0.6525,0.8272
					l-0.0356-0.01l-0.1292-1.2925l0.1664,0.0482l0.0875,0.8866l0.55-0.7018l0.1563,0.0452l0.0909,0.888L62.0462,147.1906z"/>
				<path fill="#231F20" d="M62.3176,147.2551l0.166,0.0429l-0.3009,1.1623l-0.1659-0.0433L62.3176,147.2551z"/>
				<path fill="#231F20" d="M62.8427,148.1062l-0.1081-0.1079c-0.0566-0.0523-0.1026-0.1151-0.1354-0.1848
					c-0.0224-0.0555-0.0261-0.1168-0.0107-0.1746c0.0176-0.086,0.0726-0.1596,0.15-0.2009
					c0.0832-0.0422,0.1794-0.0514,0.2691-0.0257c0.0958,0.0227,0.1824,0.0741,0.2483,0.1472l-0.0461,0.19
					c-0.0524-0.0922-0.1395-0.1596-0.2418-0.1874c-0.0473-0.0135-0.0976-0.0114-0.1436,0.0059
					c-0.038,0.013-0.0668,0.0445-0.0762,0.0836c-0.0084,0.0366-0.003,0.0751,0.0151,0.108c0.0266,0.0472,0.0608,0.0898,0.101,0.1261
					l0.11,0.1061c0.1117,0.0904,0.1636,0.2357,0.1345,0.3764c-0.0176,0.0867-0.0718,0.1616-0.1488,0.2053
					c-0.0814,0.0438-0.1767,0.054-0.2655,0.0284c-0.114-0.0268-0.2158-0.091-0.2891-0.1823l0.0511-0.2122
					c0.0459,0.1212,0.1469,0.2131,0.2718,0.2475c0.0469,0.0132,0.0971,0.0088,0.141-0.0123c0.04-0.018,0.0692-0.0538,0.0789-0.0965
					C62.9573,148.2533,62.9173,148.1623,62.8427,148.1062z"/>
				<path fill="#231F20" d="M63.6266,148.2872l-0.11-0.1055c-0.0576-0.0512-0.1049-0.1129-0.1393-0.1819
					c-0.0233-0.0551-0.0283-0.1161-0.0144-0.1743c0.016-0.0861,0.0693-0.1608,0.1455-0.204
					c0.0824-0.0441,0.1784-0.0552,0.2687-0.031c0.0962,0.0205,0.1839,0.0699,0.2512,0.1416l-0.042,0.19
					c-0.0545-0.0909-0.143-0.1564-0.2459-0.182c-0.0474-0.0124-0.0975-0.0095-0.1432,0.0082
					c-0.0378,0.0141-0.0659,0.0464-0.0745,0.0858c-0.0074,0.0367-0.0013,0.0749,0.0171,0.1075
					c0.0278,0.0467,0.063,0.0887,0.1042,0.1242l0.1115,0.1036c0.1134,0.0883,0.1683,0.2323,0.1423,0.3737
					c-0.0159,0.0871-0.0687,0.1631-0.1449,0.2083c-0.0804,0.0456-0.1755,0.0577-0.2647,0.0337
					c-0.1146-0.0245-0.2178-0.0866-0.293-0.1765l0.0469-0.213c0.0484,0.1201,0.1512,0.2099,0.2767,0.2418
					c0.0474,0.0121,0.0975,0.0068,0.1413-0.0149c0.0393-0.0192,0.0675-0.0555,0.0764-0.0983
					C63.7518,148.4525,63.7156,148.3737,63.6266,148.2872z"/>
			</g>
			<g>
				<path fill="#231F20" d="M81.1806,147.4292l0.1565-0.0364l0.27,1.17l-0.1684,0.0389l-0.21-0.91l-0.2556,0.5351l-0.031,0.0072
					l-0.4678-0.3681l0.21,0.91l-0.1671,0.0385l-0.27-1.1694l0.1585-0.0366l0.4995,0.3906L81.1806,147.4292z"/>
				<path fill="#231F20" d="M81.9161,147.2343l0.1172-0.031l0.8292,1.03l-0.17,0.0451l-0.2456-0.3031l-0.4951,0.1312l-0.0541,0.3821
					l-0.1706,0.0454L81.9161,147.2343z M82.339,147.845l-0.2985-0.37l-0.0623,0.466L82.339,147.845z"/>
				<path fill="#231F20" d="M82.9909,148.1938l-0.3429-1.1487l0.3874-0.1157c0.1258-0.044,0.2602-0.058,0.3924-0.0406
					c0.1049,0.0196,0.2019,0.0689,0.2794,0.1422c0.0803,0.0743,0.1389,0.1691,0.1695,0.2741
					c0.0229,0.0756,0.0302,0.1552,0.0213,0.2337c-0.0081,0.0786-0.0325,0.1546-0.0715,0.2232
					c-0.0392,0.0713-0.093,0.1336-0.1578,0.1828c-0.0338,0.027-0.0704,0.0503-0.1092,0.0694
					c-0.0665,0.0283-0.1349,0.0518-0.2047,0.0706L82.9909,148.1938z M83.0618,147.0811l-0.2056,0.0616l0.2558,0.8551l0.21-0.0627
					c0.0649-0.0176,0.1276-0.0425,0.187-0.074c0.0368-0.0212,0.0707-0.0471,0.1009-0.077c0.0255-0.0266,0.0472-0.0565,0.0646-0.089
					c0.0569-0.1074,0.0673-0.2334,0.0288-0.3486c-0.0436-0.1608-0.1782-0.2804-0.343-0.3047
					c-0.041-0.0067-0.0827-0.0077-0.124-0.003C83.1771,147.0486,83.1188,147.0627,83.0618,147.0811z"/>
				<path fill="#231F20" d="M83.8737,146.6729l0.6463-0.2126l0.048,0.1452l-0.4834,0.1588l0.1145,0.3479l0.4666-0.1537l0.048,0.1461
					l-0.4666,0.1535l0.1165,0.3543l0.4988-0.1641l0.0477,0.1452l-0.6617,0.2179L83.8737,146.6729z"/>
			</g>
		</g>
	</g>
	<g id="Numerals">
		<g>
			<path fill="#231F20" d="M51.7663,76.6172h1.0286v7.185h-1.0286V76.6172z"/>
			<path fill="#231F20" d="M55.2422,76.6172h1.0287v7.185h-1.0287V76.6172z"/>
		</g>
		<g>
			<path fill="#231F20" d="M39.0097,89.6105h1.0285v7.185h-1.0285V89.6105z"/>
			<path fill="#231F20" d="M43.5152,89.5179c0.6931,0.0202,1.3196,0.4178,1.633,1.0363c0.8606,1.6583,0.8606,3.6317,0,5.29
				c-0.4796,0.9283-1.6209,1.292-2.5492,0.8124c-0.3414-0.1764-0.621-0.4525-0.8016-0.7917
				c-0.8508-1.6733-0.843-3.654,0.0207-5.3206C42.1548,89.9188,42.8048,89.5257,43.5152,89.5179z M43.5252,90.4952h-0.0514
				c-0.4327,0.0266-0.8051,0.3153-0.9387,0.7277c-0.2577,0.6244-0.3762,1.2975-0.3471,1.9724
				c-0.0303,0.6835,0.0856,1.3655,0.34,2.0006c0.1352,0.5184,0.665,0.829,1.1834,0.6938c0.3398-0.0886,0.6052-0.354,0.6938-0.6938
				c0.2562-0.624,0.3738-1.2961,0.3447-1.97c0.0273-0.6791-0.0857-1.3565-0.3319-1.99c-0.2213-0.4939-0.5189-0.7407-0.8926-0.7407
				H43.5252z"/>
		</g>
		<path fill="#231F20" d="M36.0026,113.5504l-0.6326-0.7457c0.5259-0.3314,0.9962-0.7436,1.3937-1.2215
			c0.3702-0.427,0.6424-0.93,0.7973-1.4736c-0.3459,0.2078-0.7436,0.313-1.147,0.3035c-0.5361,0.0054-1.0493-0.2171-1.4118-0.6121
			c-0.7999-0.8416-0.7828-2.1676,0.0386-2.9882c0.4038-0.409,0.958-0.634,1.5327-0.6223c0.6378-0.0181,1.2499,0.252,1.6664,0.7354
			c0.4447,0.5259,0.676,1.1994,0.6481,1.8876c-0.0203,0.9388-0.3017,1.8533-0.8127,2.6411
			C37.5657,112.3119,36.8541,113.0314,36.0026,113.5504z M37.7615,109.0862c0.0307-0.177,0.0514-0.3556,0.0618-0.5349
			c0.0153-0.3709-0.1085-0.7341-0.3473-1.0183c-0.2224-0.26-0.5503-0.4056-0.8923-0.3961
			c-0.3103-0.0091-0.6101,0.1133-0.8254,0.3369c-0.2185,0.2264-0.3363,0.5316-0.3266,0.8461
			c-0.002,0.3074,0.1271,0.6011,0.3549,0.8075c0.226,0.2222,0.5317,0.3447,0.8486,0.34
			C37.041,109.46,37.4346,109.3268,37.7615,109.0862z"/>
		<path fill="#231F20" d="M41.1468,122.9184c0.2694-0.0006,0.5363,0.0515,0.7857,0.1533c0.2469,0.0989,0.4735,0.2425,0.6684,0.4234
			c0.1928,0.1788,0.3488,0.3937,0.4591,0.6324c0.1121,0.2411,0.1696,0.5041,0.1684,0.77c0.0057,0.5242-0.2134,1.0258-0.6019,1.3778
			c0.3057,0.2081,0.5632,0.4795,0.7549,0.7958c0.1668,0.2993,0.2513,0.6374,0.2449,0.98c0.0017,0.2924-0.0665,0.581-0.1988,0.8417
			c-0.1335,0.2629-0.3152,0.4983-0.5358,0.6939c-0.2309,0.2046-0.4971,0.3655-0.7857,0.4746
			c-0.3028,0.1162-0.6246,0.175-0.9489,0.1734c-0.3313,0.0029-0.6602-0.0559-0.97-0.1734
			c-0.2877-0.1086-0.5537-0.2675-0.7857-0.4694c-0.2216-0.1934-0.402-0.4294-0.5305-0.6939
			c-0.129-0.2636-0.1954-0.5534-0.194-0.8469c-0.0118-0.6146,0.2636-1.1995,0.7449-1.5819
			c0.0705-0.0676,0.1494-0.1259,0.2348-0.1734c-0.3807-0.366-0.5978-0.8699-0.6022-1.398c-0.0012-0.2659,0.0564-0.5289,0.1685-0.77
			c0.1083-0.2359,0.2607-0.4489,0.449-0.6275c0.1932-0.1806,0.418-0.3241,0.6631-0.4235
			C40.5924,122.9709,40.8684,122.917,41.1468,122.9184z M41.1468,126.745c-0.1841,0.0001-0.367,0.0311-0.5408,0.0918
			c-0.1687,0.0568-0.3259,0.1432-0.4643,0.2552c-0.1312,0.1072-0.2404,0.2388-0.3214,0.3876
			c-0.0818,0.1503-0.124,0.3189-0.1225,0.49c-0.0017,0.1705,0.0386,0.3388,0.1173,0.49c0.0788,0.1504,0.1863,0.2839,0.3164,0.3929
			c0.1372,0.1149,0.2947,0.203,0.4643,0.26c0.1806,0.0618,0.3704,0.0928,0.5613,0.0918c0.1824,0.0002,0.3635-0.0309,0.5355-0.0918
			c0.1669-0.0574,0.3224-0.1437,0.4593-0.2551c0.1313-0.1071,0.2404-0.2388,0.3214-0.3877c0.0827-0.1535,0.1248-0.3256,0.1224-0.5
			c0.0015-0.1711-0.0406-0.3397-0.1224-0.49c-0.0819-0.1497-0.1928-0.2815-0.3264-0.3876c-0.2824-0.2222-0.6307-0.3443-0.99-0.347
			L41.1468,126.745z M41.9019,124.245c-0.2002-0.1984-0.4734-0.3054-0.7551-0.2958c-0.1524-0.0021-0.3035,0.0273-0.4439,0.0865
			c-0.1263,0.0537-0.2408,0.1319-0.3368,0.23c-0.0891,0.0912-0.16,0.1985-0.2091,0.3161c-0.0471,0.1132-0.0714,0.2346-0.0714,0.3573
			c-0.0005,0.1336,0.0273,0.2657,0.0817,0.3877c0.0526,0.1198,0.1269,0.2289,0.2193,0.3216
			c0.0952,0.094,0.2078,0.1685,0.3316,0.2194c0.136,0.0556,0.2817,0.0832,0.4286,0.0813c0.1381,0.001,0.275-0.025,0.4031-0.0765
			c0.1245-0.05,0.2386-0.1227,0.3367-0.2142c0.0977-0.0904,0.176-0.1998,0.23-0.3215c0.0549-0.1254,0.0827-0.2609,0.0815-0.3978
			C42.1916,124.6784,42.0856,124.4301,41.9019,124.245z"/>
		<path fill="#231F20" d="M51.9189,136.0723h4.65l-3.2514,7.2693l-0.92-0.3876l2.6276-5.8994h-3.1062
			C51.9189,137.0546,51.9189,136.0723,51.9189,136.0723z"/>
		<path fill="#231F20" d="M90.1515,135.7195h3.189v0.9156h-2.253v1.8155c0.0723-0.0068,0.1459-0.01,0.2214-0.01
			c0.634-0.0231,1.2515,0.2052,1.7179,0.6353c0.4466,0.4172,0.692,1.0064,0.6737,1.6173c0.023,0.6193-0.2192,1.219-0.6659,1.6486
			c-0.4681,0.4325-1.089,0.6609-1.7257,0.635c-0.5914-0.002-1.1736-0.1467-1.6971-0.4218v-1.0595
			c0.4454,0.3128,0.9728,0.4881,1.5168,0.5042c0.3968,0.0125,0.7843-0.1222,1.0877-0.3782
			c0.5115-0.4166,0.5884-1.1689,0.1718-1.6804c-0.0616-0.0756-0.1322-0.1434-0.2102-0.2018
			c-0.341-0.2628-0.763-0.3983-1.1932-0.3831c-0.2817-0.0183-0.5644,0.0166-0.8332,0.1028L90.1515,135.7195z"/>
		<path fill="#231F20" d="M104.6874,126.3165v1.1021h1.0608v1.03h-1.0611v1.7449h-1.0207v-1.7449h-2.9382l2.7548-5.49h1.1529
			l-2.2445,4.4591h1.2752v-1.1021L104.6874,126.3165z"/>
		<path fill="#231F20" d="M102.827,95.5725h2.7353v0.9925h-4.547v-0.0719l0.4323-0.5092c0.6757-0.8367,1.2132-1.5465,1.6124-2.1293
			c0.3019-0.4148,0.5637-0.8574,0.7818-1.3218c0.1179-0.2802,0.1798-0.5807,0.1823-0.8846
			c0.0171-0.3574-0.1065-0.7074-0.3444-0.9747c-0.238-0.2485-0.5714-0.3825-0.9152-0.3676c-0.302,0.004-0.5969,0.0921-0.8515,0.2545
			c-0.2967,0.1861-0.5529,0.4302-0.7532,0.7175v-1.3065c0.4774-0.4244,1.0892-0.6666,1.7277-0.6839
			c0.5822-0.0184,1.1451,0.2094,1.5506,0.6275c0.4101,0.4275,0.6301,1.0025,0.61,1.5945c-0.0042,0.3136-0.0553,0.6249-0.1517,0.9234
			c-0.1341,0.397-0.3145,0.7768-0.5377,1.1315c-0.3948,0.6127-0.8329,1.1963-1.3111,1.7464L102.827,95.5725z"/>
		<path fill="#231F20" d="M90.8903,76.6172h1.0292v7.1851h-1.0292V76.6172z"/>
		<g>
			<path fill="#231F20" d="M68.9796,71.7821h1.0286v7.185h-1.0286V71.7821z"/>
			<path fill="#231F20" d="M72.9824,77.9744h2.7346v0.9926h-4.5464v-0.072l0.4321-0.5092c0.6753-0.8366,1.2126-1.5464,1.6121-2.1293
				c0.3021-0.4147,0.5638-0.8573,0.7818-1.3217c0.1181-0.2801,0.1802-0.5807,0.1829-0.8847c0.017-0.3575-0.1069-0.7074-0.345-0.9746
				c-0.2378-0.2488-0.5715-0.3828-0.9153-0.3677c-0.3018,0.0041-0.5966,0.0922-0.8511,0.2545
				c-0.2968,0.1861-0.5531,0.4301-0.7535,0.7175v-1.3064c0.4776-0.4244,1.0896-0.6667,1.7283-0.684
				c0.5822-0.0184,1.1451,0.2094,1.5506,0.6275c0.4099,0.4275,0.6296,1.0026,0.6093,1.5945
				c-0.0042,0.3136-0.0553,0.6249-0.1517,0.9234c-0.1335,0.3972-0.3137,0.777-0.537,1.1316
				c-0.395,0.6125-0.8331,1.1961-1.311,1.7463L72.9824,77.9744z"/>
		</g>
		<path fill="#231F20" d="M72.7292,140.9679l0.1021-0.072l0.6224,0.7815c-0.5079,0.3198-0.9676,0.7104-1.3651,1.16
			c-0.3708,0.4349-0.6545,0.937-0.8358,1.479c0.3498-0.1877,0.7397-0.2883,1.1367-0.2933c0.5402-0.0107,1.0596,0.208,1.4294,0.6019
			c0.3848,0.3935,0.5944,0.9258,0.5813,1.476c0.0104,0.575-0.2188,1.1283-0.6328,1.5275c-0.4046,0.4113-0.9605,0.6382-1.5374,0.6275
			c-0.6256,0.0218-1.2275-0.24-1.6381-0.7125c-0.4331-0.522-0.6559-1.1868-0.6248-1.8643c0.0022-0.5881,0.1111-1.1708,0.3214-1.72
			c0.2202-0.5813,0.5328-1.1233,0.9257-1.6049C71.6517,141.8235,72.1617,141.3568,72.7292,140.9679z M71.0316,145.3807
			c-0.0287,0.1785-0.0424,0.3592-0.041,0.54c-0.0142,0.3653,0.1118,0.7222,0.3522,0.9976c0.228,0.2578,0.5587,0.401,0.9027,0.3909
			c0.3068,0.0092,0.6031-0.1123,0.815-0.3343c0.2159-0.2266,0.3318-0.5305,0.3216-0.8433c0.0123-0.3166-0.1125-0.6231-0.3425-0.841
			c-0.2469-0.2213-0.571-0.3367-0.9022-0.3213c-0.1778-0.0025-0.3547,0.0271-0.522,0.0873
			C71.4091,145.1422,71.2133,145.251,71.0316,145.3807L71.0316,145.3807z"/>
	</g>
	<g id="S_Logo">
		<g id="Printed">
			<path fill="#231F20" d="M66.4714,93.0522c0.8578,0.0622,1.069,0.17,1.069,0.8338c0,0.48,0.0186,0.95-1.2539,0.95
				c-0.7386,0-1.2285-0.0153-1.2285-0.9652h0.7409c0,0.3008,0.1081,0.3327,0.4876,0.3327c0.3627,0,0.4815-0.0241,0.4815-0.2666
				c0-0.2518-0.0427-0.2476-0.4053-0.2707l-0.17-0.0112c-0.7139-0.05-1.1315-0.0466-1.1315-0.8768s0.4674-0.8828,1.2252-0.8828
				c0.6315,0,1.1722,0.01,1.1722,0.81v0.12h-0.74c0-0.2972-0.1237-0.2972-0.4323-0.2972c-0.4179,0-0.4535,0.085-0.4535,0.2464
				c0,0.2324,0.1117,0.24,0.3178,0.2546L66.4714,93.0522z"/>
			<path fill="#231F20" d="M71.3552,91.9165h0.7754l-0.64,2.8961h-1.1172l-0.3938-1.8145h-0.03l-0.4219,1.8145h-1.1028
				l-0.625-2.8961h0.7822l0.4173,2.2324h0.027l0.5446-2.2324h0.8024l0.52,2.2324h0.0244L71.3552,91.9165z"/>
			<path fill="#231F20" d="M73.2638,94.8127h-0.7742v-2.8961h0.7742V94.8127z"/>
			<path fill="#231F20" d="M75.211,93.0522c0.8581,0.0622,1.0693,0.17,1.0693,0.8338c0,0.48,0.0209,0.95-1.2529,0.95
				c-0.7379,0-1.23-0.0153-1.23-0.9652h0.7425c0,0.3008,0.1071,0.3327,0.487,0.3327c0.3627,0,0.4834-0.0241,0.4834-0.2666
				c0-0.2518-0.0433-0.2476-0.4078-0.2707l-0.1693-0.0112c-0.7139-0.05-1.13-0.0466-1.13-0.8768s0.4658-0.8828,1.2239-0.8828
				c0.6316,0,1.1726,0.01,1.1726,0.81v0.12h-0.741c0-0.2972-0.1243-0.2972-0.4316-0.2972c-0.4179,0-0.4531,0.085-0.4531,0.2464
				c0,0.2324,0.1126,0.24,0.3174,0.2546L75.211,93.0522z"/>
			<path fill="#231F20" d="M78.1306,93.0522c0.8568,0.0622,1.0687,0.17,1.0687,0.8338c0,0.48,0.02,0.95-1.2543,0.95
				c-0.7366,0-1.2271-0.0153-1.2271-0.9652h0.74c0,0.3008,0.1094,0.3327,0.4869,0.3327c0.3627,0,0.4828-0.0241,0.4828-0.2666
				c0-0.2518-0.042-0.2476-0.4046-0.2707l-0.1712-0.0112c-0.7133-0.05-1.13-0.0466-1.13-0.8768s0.4677-0.8828,1.2235-0.8828
				c0.6342,0,1.1739,0.01,1.1739,0.81v0.12h-0.7416c0-0.2972-0.1236-0.2972-0.4323-0.2972c-0.4159,0-0.4508,0.085-0.4508,0.2464
				c0,0.2324,0.1117,0.24,0.3145,0.2546L78.1306,93.0522z"/>
			<path fill="#231F20" d="M65.3793,98.284v-2.83h1.5937c0.3549-0.0415,0.7123,0.0542,0.9991,0.2674
				c0.2109,0.2975,0.3046,0.6624,0.263,1.0247c0.0423,0.4238-0.039,0.8508-0.2341,1.2294c-0.2459,0.2406-0.589,0.3545-0.93,0.3086
				L65.3793,98.284z M65.7676,98.0139h1.1221c0.2818,0.0388,0.5676-0.0339,0.7965-0.2027c0.1519-0.2763,0.2138-0.5931,0.1771-0.9062
				c0.0353-0.3333-0.0177-0.67-0.1536-0.9764c-0.1038-0.1375-0.3506-0.2054-0.7419-0.2054h-1.2L65.7676,98.0139z"/>
			<path fill="#231F20" d="M69.2082,95.7231v0.9645h1.7471v0.2689h-1.7471v1.0573h1.8233v0.27h-2.2121v-2.83h2.2116v0.2692
				L69.2082,95.7231z"/>
			<path fill="#231F20" d="M72.1234,95.4538v2.5334h1.7692v0.2967h-2.1569v-2.83L72.1234,95.4538z"/>
			<path fill="#231F20" d="M75.129,95.7504v2.5336h-0.3887v-2.5336h-1.1208v-0.2965H76.24v0.2965H75.129z"/>
			<path fill="#231F20" d="M78.4945,97.6846h-1.7428l-0.2636,0.5993h-0.41l1.26-2.83h0.5449l1.2842,2.83h-0.4059L78.4945,97.6846z
				 M78.381,97.4439l-0.7624-1.7295l-0.7553,1.7295H78.381z"/>
		</g>
		<g id="Logo">
			<path fill="none" d="M76.1182,88.7585c-0.0714-0.1892-0.2071-0.5209-0.2725-0.6763c-0.6621-1.5546-1.5182-3.0193-2.5479-4.3591
				c-0.0482-0.0636-0.14-0.1805-0.2252-0.2879c-0.0433-0.0544-0.0841-0.1057-0.1208-0.1472
				c-0.0274-0.0365-0.0571-0.0711-0.0889-0.1038c-0.3346-0.3159-0.8371-0.3744-1.2353-0.1437
				c-0.0636,0.0365-0.1226,0.0805-0.1758,0.1309c-0.019,0.0152-0.0363,0.0324-0.0517,0.0512
				c-0.1068,0.1231-0.3422,0.4334-0.4161,0.5295c-0.5323,0.6911-1.0177,1.4172-1.4528,2.1733
				c-0.4339,0.751-0.8181,1.5297-1.15,2.3311c-0.0258,0.0628-0.08,0.1909-0.1289,0.3044c-0.0241,0.0568-0.0482,0.1108-0.0644,0.1513
				c-0.0192,0.0448-0.028,0.0661-0.0352,0.0858c-0.0456,0.1177-0.0689,0.2428-0.0686,0.369
				c0.0002,0.4565,0.2976,0.8596,0.7337,0.9945c0.0801,0.0233,0.1627,0.0374,0.246,0.042c1.015,0.1615,2.0413,0.2414,3.069,0.2389
				c0.6785,0.0004,1.3565-0.0334,2.0316-0.1014c0.194-0.02,0.79-0.092,1.2158-0.1607c0.2858-0.0571,0.5315-0.2382,0.6707-0.4943
				c0.0185-0.0334,0.0272-0.0532,0.0306-0.061l0.0016-0.0008v-0.0025l0.0019-0.0027c0.0052-0.01,0.0136-0.0275,0.0257-0.0541
				c0.0572-0.1327,0.087-0.2755,0.0876-0.42c0.0003-0.0779-0.009-0.1555-0.0277-0.2311
				C76.1565,88.861,76.1389,88.8091,76.1182,88.7585z M75.6588,89.3672l-0.0016,0.0024v0.0026l-0.014,0.0287l-0.0028,0.0083
				l-0.0151,0.03c-0.0656,0.1289-0.1847,0.2224-0.3255,0.2554c-0.4063,0.0661-1.0049,0.1376-1.1842,0.1565
				c-0.6589,0.0671-1.3209,0.1005-1.9832,0.1c-1.006,0.0022-2.0106-0.076-3.0042-0.2339l-0.0124-0.0034h-0.0157
				c-0.0467-0.0015-0.093-0.009-0.1377-0.0224c-0.2294-0.0715-0.3859-0.2838-0.3863-0.5241
				c-0.0003-0.0659,0.0118-0.1314,0.0358-0.1928v-0.0009c0.0189-0.0438,0.1712-0.3994,0.2253-0.5295
				c0.6505-1.5678,1.5032-3.0439,2.5364-4.3906c0.0419-0.0566,0.1393-0.1822,0.2311-0.2993c0.0449-0.0577,0.09-0.1135,0.123-0.1555
				c0.0193-0.0224,0.032-0.04,0.044-0.0526l0.01-0.011c0.0287-0.026,0.0599-0.049,0.0932-0.0686
				c0.209-0.1201,0.4718-0.0902,0.6484,0.0738c0.015,0.0146,0.0961,0.1143,0.1722,0.2106c0.0817,0.1031,0.168,0.214,0.2142,0.2723
				c1.0045,1.3062,1.8394,2.7345,2.4845,4.2507c0.0413,0.0981,0.1152,0.2795,0.1806,0.4418
				c0.0326,0.0818,0.0632,0.1593,0.0846,0.2187c0.0114,0.0291,0.02,0.0548,0.027,0.0719l0.0066,0.0208v0.0018
				c0.0089,0.0383,0.0135,0.0774,0.0139,0.1167C75.7061,89.222,75.6897,89.2974,75.6588,89.3672L75.6588,89.3672z"/>
			<path fill="#231F20" d="M76.3082,88.8833c-0.0159-0.0587-0.0351-0.1164-0.0576-0.1729
				c-0.0726-0.1941-0.2089-0.5254-0.2738-0.6836c-0.3212-0.7525-0.6875-1.485-1.0969-2.1935
				c-0.4407-0.764-0.9321-1.4977-1.4708-2.1961c-0.0492-0.0645-0.1392-0.1817-0.2281-0.29c-0.0408-0.0542-0.0841-0.1064-0.12-0.15
				c-0.0308-0.0406-0.0646-0.0788-0.1012-0.1142c-0.2194-0.2076-0.5099-0.3232-0.8119-0.3232h-0.0016
				c-0.2071,0.0004-0.4105,0.0549-0.59,0.1582c-0.0715,0.0423-0.1385,0.0918-0.2,0.1476l-0.108,0.1l0.0078,0.01
				c-0.1224,0.1476-0.3174,0.4039-0.3848,0.4907c-1.0684,1.3909-1.9493,2.9162-2.62,4.5368c-0.026,0.0612-0.08,0.1891-0.1285,0.3026
				c-0.0248,0.0562-0.0476,0.11-0.0655,0.1513c-0.0173,0.0432-0.0277,0.0663-0.0378,0.0894
				c-0.2314,0.611,0.0763,1.2939,0.6873,1.5253c0.0229,0.0087,0.0461,0.0166,0.0695,0.0239
				c0.0882,0.0263,0.1791,0.0427,0.2709,0.049c1.0203,0.1607,2.0517,0.2405,3.0846,0.2389
				c0.6838,0.0005,1.3671-0.0343,2.0473-0.1042c0.1962-0.0195,0.7907-0.0909,1.2232-0.1614
				c0.3276-0.0625,0.6099-0.2685,0.7693-0.5614c0.012-0.0213,0.02-0.0378,0.0257-0.05l0.0068-0.0147l0.0016-0.0052l0.0036-0.0032
				v-0.0036l0.002-0.0024c0.01-0.019,0.0188-0.0385,0.0263-0.0586c0.0668-0.149,0.1012-0.3104,0.101-0.4737
				C76.3388,89.057,76.3286,88.9691,76.3082,88.8833z M76.1106,89.5649c-0.0121,0.0266-0.02,0.044-0.0257,0.0541l-0.0019,0.0027
				v0.0025l-0.0016,0.0008c-0.0034,0.0078-0.0121,0.0276-0.0306,0.061c-0.1392,0.2561-0.3849,0.4372-0.6707,0.4943
				c-0.4257,0.0687-1.0218,0.14-1.2158,0.1607c-0.6751,0.068-1.3531,0.1018-2.0316,0.1014c-1.0277,0.0025-2.054-0.0774-3.069-0.2389
				c-0.0833-0.0046-0.1659-0.0187-0.246-0.042c-0.4361-0.1349-0.7335-0.538-0.7337-0.9945c-0.0003-0.1262,0.023-0.2513,0.0686-0.369
				c0.0072-0.02,0.016-0.041,0.0352-0.0858c0.0162-0.04,0.04-0.0945,0.0644-0.1513c0.0492-0.1135,0.1031-0.2416,0.1289-0.3044
				c0.3319-0.8014,0.7161-1.5801,1.15-2.3311c0.4351-0.7561,0.9205-1.4822,1.4528-2.1733c0.0739-0.0961,0.3093-0.4064,0.4161-0.5295
				c0.0154-0.0188,0.0327-0.036,0.0517-0.0512c0.0532-0.0504,0.1122-0.0944,0.1758-0.1309
				c0.3982-0.2307,0.9007-0.1722,1.2353,0.1437c0.0318,0.0327,0.0615,0.0673,0.0889,0.1038
				c0.0367,0.0415,0.0775,0.0928,0.1208,0.1472c0.0852,0.1074,0.177,0.2243,0.2252,0.2879
				c1.0297,1.3398,1.8858,2.8045,2.5479,4.3591c0.0654,0.1554,0.2011,0.4871,0.2725,0.6763c0.0206,0.0507,0.038,0.1027,0.052,0.1557
				c0.0187,0.0756,0.028,0.1532,0.0277,0.2311c-0.0005,0.1443-0.0303,0.2871-0.0874,0.4196
				C76.1104,89.5649,76.1106,89.5649,76.1106,89.5649z M75.6927,89.0286c0.0089,0.0383,0.0135,0.0774,0.0139,0.1167
				c-0.0006,0.0764-0.0168,0.1519-0.0475,0.2219l-0.0016,0.0024v0.0026l-0.014,0.0287l-0.0028,0.0083l-0.0151,0.03
				c-0.0656,0.1289-0.1847,0.2224-0.3255,0.2554c-0.4063,0.0661-1.0049,0.1376-1.1842,0.1565
				c-0.6589,0.0671-1.3209,0.1005-1.9832,0.1c-1.0061,0.0022-2.0108-0.076-3.0045-0.2339l-0.0124-0.0034h-0.0157
				c-0.0467-0.0015-0.093-0.009-0.1377-0.0224c-0.2294-0.0715-0.3859-0.2838-0.3863-0.5241
				c-0.0003-0.0659,0.0118-0.1314,0.0358-0.1928v-0.0009c0.0189-0.0438,0.1712-0.3994,0.2253-0.5295
				c0.6505-1.5678,1.5032-3.0439,2.5364-4.3906c0.0419-0.0566,0.1393-0.1822,0.2311-0.2993c0.0449-0.0577,0.09-0.1135,0.123-0.1555
				c0.0193-0.0224,0.032-0.04,0.044-0.0526l0.01-0.011c0.0287-0.026,0.0599-0.049,0.0932-0.0686
				c0.209-0.1201,0.4718-0.0902,0.6484,0.0738c0.015,0.0146,0.0961,0.1143,0.1722,0.2106c0.0817,0.1031,0.168,0.214,0.2142,0.2723
				c1.0045,1.3062,1.8394,2.7345,2.4845,4.2507c0.0413,0.0981,0.1152,0.2795,0.1806,0.4418
				c0.0326,0.0818,0.0632,0.1593,0.0846,0.2187c0.0114,0.0291,0.02,0.0548,0.027,0.0719l0.0066,0.0208L75.6927,89.0286z"/>
			<polygon fill="#FFFFFF" points="74.1272,86.6963 72.7322,86.6963 72.7322,85.2803 71.5752,85.2803 71.5752,86.6963
				70.1582,86.6963 70.1582,87.8532 71.5752,87.8532 71.5752,89.2482 72.7322,89.2482 72.7322,87.8532 74.1272,87.8532 			"/>
		</g>
	</g>
	<g id="A-04DD">
		<g>
			<path fill="#231F20" d="M71.3519,128.3172h0.9v0.3525h-0.9V128.3172z"/>
			<path fill="#231F20" d="M73.3396,126.7561c0.2434,0.007,0.4635,0.1466,0.5735,0.3639c0.3026,0.5826,0.3026,1.2759,0,1.8585
				c-0.1685,0.3261-0.5694,0.4539-0.8955,0.2854c-0.12-0.062-0.2183-0.1591-0.2817-0.2783
				c-0.2986-0.5879-0.2959-1.2837,0.0074-1.8692C72.8617,126.8968,73.09,126.7588,73.3396,126.7561z M73.3432,127.0992H73.325
				c-0.1522,0.0091-0.2832,0.1107-0.33,0.2558c-0.0907,0.2193-0.1323,0.4558-0.1221,0.6929
				c-0.0106,0.2401,0.0303,0.4798,0.12,0.7028c0.0474,0.1821,0.2335,0.2913,0.4156,0.2438
				c0.1194-0.0311,0.2127-0.1244,0.2438-0.2438c0.09-0.2192,0.1314-0.4553,0.1211-0.692c0.0096-0.2386-0.0301-0.4766-0.1166-0.6992
				C73.579,127.1861,73.4744,127.0994,73.3432,127.0992z"/>
		</g>
		<path fill="#231F20" d="M75.3695,126.8113l0.035-0.0246l0.2132,0.2676c-0.174,0.1095-0.3314,0.2433-0.4676,0.3973
			c-0.127,0.1489-0.2242,0.3209-0.2863,0.5065c0.1199-0.0641,0.2534-0.0984,0.3894-0.1c0.1851-0.0038,0.3632,0.0711,0.49,0.2061
			c0.1318,0.1348,0.2036,0.3171,0.1991,0.5056c0.0036,0.1969-0.0749,0.3865-0.2167,0.5232
			c-0.1386,0.1409-0.3291,0.2187-0.5267,0.215c-0.2143,0.0074-0.4205-0.0823-0.5611-0.2441
			c-0.1484-0.1788-0.2247-0.4065-0.214-0.6386c0.0007-0.2014,0.038-0.4011,0.11-0.5892c0.0754-0.1992,0.1825-0.3849,0.3171-0.55
			C75.0006,127.1043,75.1752,126.9445,75.3695,126.8113z M74.7881,128.3228c-0.0099,0.0612-0.0146,0.123-0.0141,0.185
			c-0.0048,0.1251,0.0383,0.2473,0.1206,0.3417c0.0781,0.0883,0.1914,0.1373,0.3092,0.1339
			c0.1051,0.0032,0.2066-0.0385,0.2792-0.1145c0.0739-0.0777,0.1135-0.1817,0.11-0.2889c0.0042-0.1084-0.0386-0.2134-0.1173-0.2881
			c-0.0846-0.0758-0.1956-0.1153-0.3091-0.11c-0.0609-0.0008-0.1215,0.0093-0.1788,0.03
			C74.9172,128.2412,74.8503,128.2784,74.7881,128.3228L74.7881,128.3228z"/>
		<path fill="#231F20" d="M70.3902,128.7626h-1.56l-0.2383,0.5372h-0.3672l1.1289-2.5348h0.487l1.1516,2.5348h-0.363
			L70.3902,128.7626z M70.2874,128.5231l-0.6817-1.5472l-0.6751,1.5472H70.2874z"/>
	</g>
	<g id="_517_3H_Window">
		<polygon fill="#FFFFFF" points="104.8232,107.1722 105.6732,106.3223 105.6732,113.6933 104.8232,112.8412 		"/>
		<polygon fill="#E6E7E7" points="82.7132,107.1722 81.8642,106.3223 105.6732,106.3223 104.8232,107.1722 		"/>
		<polygon fill="#D0D2D3" points="82.7132,112.8412 81.8642,113.6933 81.8642,106.3223 82.7132,107.1722 		"/>
		<polygon fill="#FFFFFF" points="104.8232,112.8412 105.6732,113.6933 81.8642,113.6933 82.7132,112.8412 		"/>
		<polygon fill="#FFFFFF" points="96.1782,107.1732 96.1782,112.8423 96.6742,113.3402 96.6742,106.6772 		"/>
		<polygon fill="#D0D2D3" points="97.1702,107.1732 96.6742,106.6772 96.6742,113.3402 97.1702,112.8423 		"/>
	</g>
</g>
<g id="Hands_A-06">
	<g id="Hour_A-06">
    <path fill="#332D2F" d="M69.2639,111.948c-1.0946-1.5168-0.7524-3.6337,0.7644-4.7283c0.5757-0.4155,1.2675-0.6396,1.9775-0.6405
      c1.8702-0.0018,3.3877,1.5129,3.3894,3.383c0.0018,1.8702-1.5129,3.3877-3.383,3.3894
      C70.9238,113.3527,69.9011,112.8304,69.2639,111.948z M73.5167,108.878c-0.6003-0.8329-1.7623-1.0215-2.5952-0.4212
      c-0.833,0.6004-1.0215,1.7623-0.4212,2.5952c0.6003,0.8329,1.7623,1.0215,2.5952,0.4212
      c0.4854-0.3498,0.7727-0.9119,0.7721-1.5101C73.8687,109.5733,73.7458,109.1934,73.5167,108.878z"/>
    <path fill="#595A5C" d="M74.7672,107.9743l-0.0254,0.0184c1.0897,1.5088,0.7499,3.6154-0.7589,4.7051
      c-0.5734,0.4141-1.2627,0.6373-1.97,0.638c-1.0831-0.0005-2.1003-0.5198-2.7358-1.3968
      c-1.0896-1.5089-0.7498-3.6154,0.7591-4.7051c0.5734-0.4141,1.2625-0.6373,1.9698-0.6379
      c1.083,0.0006,2.1003,0.5199,2.736,1.3969l0.0255-0.0184 M70.4896,111.0631c0.6059,0.8392,1.7775,1.0284,2.6168,0.4225
      c0.4886-0.3528,0.7778-0.919,0.7772-1.5217c0.0006-0.3935-0.1235-0.777-0.3546-1.0954c-0.606-0.8393-1.7777-1.0284-2.6169-0.4223
      c-0.4886,0.3528-0.7777,0.9191-0.7771,1.5218C70.1345,110.3613,70.2587,110.7448,70.4896,111.0631 M74.7672,107.9743
      c-1.0996-1.5234-3.2259-1.8668-4.7493-0.7672c-1.5234,1.0996-1.8668,3.2259-0.7672,4.7493
      c1.0996,1.5234,3.2259,1.8668,4.7493,0.7672c0.8868-0.6402,1.4117-1.6676,1.4107-2.7614
      C75.4105,109.2485,75.1853,108.5529,74.7672,107.9743z M70.5152,111.0446c-0.5958-0.8252-0.4097-1.9771,0.4154-2.5728
      c0.8251-0.5957,1.9771-0.4097,2.5728,0.4154c0.5958,0.8252,0.4097,1.9771-0.4154,2.5728
      c-0.3134,0.2263-0.69,0.3483-1.0766,0.3487C71.4185,111.8107,70.8613,111.526,70.5152,111.0446z"/>
    <polygon fill="#FFFFFF" points="69.1714,99.7618 71.9807,84.0232 74.8257,99.7559 73.4977,106.6799 70.5144,106.6828 			"/>
    <path fill="#332D2F" d="M71.9841,86.4282l2.4089,13.325l-1.2472,6.5022l-2.2812,0.0027l-1.2605-6.4996l2.3802-13.3301
       M71.9792,81.6197l-3.2405,18.1455l1.4247,7.3447l3.685-0.0042l1.4095-7.3478l-3.2791-18.1384L71.9792,81.6197z"/>
    <rect x="70.1638" y="102.8784" transform="matrix(1 -0.0011 0.0011 1 -0.112 0.0768)" fill="#332D2F" width="3.685" height="4.5378"/>
	</g>
	<g id="Minute_A-06">
    <path fill="#332D2F" d="M74.64,110.9537c-0.5368,1.462-2.1571,2.212-3.6192,1.6752c-1.462-0.5368-2.212-2.1571-1.6752-3.6192
      c0.4078-1.1106,1.4654-1.8486,2.6484-1.848c1.5577,0.0011,2.8196,1.2647,2.8185,2.8224
      C74.8124,110.3149,74.754,110.6432,74.64,110.9537z M70.6482,109.4865c-0.2729,0.7429,0.1081,1.5665,0.8511,1.8393
      c0.7429,0.2729,1.5664-0.1081,1.8393-0.8511l0,0c0.2752-0.7421-0.1033-1.5668-0.8453-1.842
      c-0.7421-0.2752-1.5667,0.1032-1.842,0.8453C70.6503,109.4808,70.6493,109.4836,70.6482,109.4865z"/>
    <path fill="#595A5C" d="M69.3326,109.0017l0.0295,0.0108c0.5337-1.4538,2.1449-2.1998,3.5988-1.6661
      c1.4538,0.5337,2.1998,2.1449,1.6661,3.5988c-0.5337,1.4538-2.145,2.1998-3.5988,1.6661
      c-1.1037-0.4051-1.8374-1.4558-1.8378-2.6314c0.0001-0.3301,0.0582-0.6576,0.1718-0.9674L69.3326,109.0017 M73.3537,110.4807
      c0.2766-0.7511-0.1081-1.5842-0.8592-1.8607c-0.7511-0.2766-1.5841,0.1081-1.8607,0.8592
      c-0.2766,0.7511,0.1081,1.5842,0.8592,1.8607c0.1602,0.059,0.3296,0.0892,0.5003,0.0892
      C72.6013,111.4308,73.1451,111.0517,73.3537,110.4807 M69.3325,109.0019c-0.5405,1.4694,0.2125,3.0989,1.6819,3.6394
      c1.4694,0.5405,3.0989-0.2125,3.6395-1.682s-0.2125-3.0989-1.6819-3.6394c-0.3132-0.1152-0.6443-0.1742-0.978-0.1743
      C70.8048,107.1431,69.741,107.885,69.3325,109.0019z M73.3241,110.4697c-0.2698,0.7354-1.0848,1.1127-1.8201,0.8428
      c-0.7354-0.2698-1.1127-1.0847-0.8428-1.8201c0.2698-0.7354,1.0847-1.1127,1.8201-0.8428
      c0.5584,0.2049,0.9295,0.7364,0.9297,1.3312C73.411,110.1477,73.3816,110.3132,73.3241,110.4697z"/>
    <polygon fill="#FFFFFF" points="70.9432,107.1008 69.1655,95.2331 71.9996,71.1089 74.8258,95.2334 73.0455,107.1011 			"/>
    <path fill="#332D2F" d="M71.9992,74.7577l2.3987,20.4687l-1.7186,11.4486l-1.3699,0l-1.7153-11.4492l2.4053-20.4685
       M72.0006,67.4605l-3.2648,27.779l1.8406,12.286l2.8345,0l1.8442-12.2851L72,67.4607L72.0006,67.4605z"/>
		<polygon fill="#332D2F" points="74.1306,98.9256 73.4116,103.455 73.4114,107.9859 70.5764,107.9845 70.5772,103.4549
			69.8813,98.9246 		"/>
	</g>
	<g id="Second_A-06">
    <path fill="#231F20" d="M73.8831,109.9996c-0.0003,1.0396-0.8433,1.8821-1.8829,1.8818
      c-1.0396-0.0003-1.8822-0.8433-1.8818-1.8829c0.0003-1.0388,0.8421-1.881,1.8808-1.8819
      C73.039,108.1174,73.8819,108.9598,73.8831,109.9996z"/>
    <line fill="none" x1="72.1148" y1="111.8827" x2="71.8871" y2="111.8827"/>
    <polygon fill="#231F20" points="71.7168,111.8826 72.2839,111.8819 72.8508,124.172 71.15,124.1719 			"/>
    <line fill="none" stroke="#231F20" stroke-width="0.5669" stroke-linecap="round" stroke-miterlimit="10" x1="72" y1="111.8827" x2="72.0003" y2="67.48"/>
	</g>
</g>
</svg>
</template>

<script>
export default {
  name: 'a06',
};
</script>
